import {GestionePlus} from "@commons/services/presenze_calcolo/GestionePlus";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {DateTime} from "luxon";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import {LavoratorePresenzeProprietaULRecord} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {Timbrature} from "@commons/services/presenze_calcolo/sub_calcolo/Timbrature";
import {LavoratoreStatusRecord} from "@commons/mapping/LavoratoreStatusRecord";
import {GiustificazioneAutoRecord, GiustificazioneRecord} from "@commons/mapping/GiustificazioneAutoRecord";
import {TabellePresenze} from "@commons/mapping/TabellePresenze";
import {FlexRecord} from "@commons/mapping/FlexRecord";
import {TabellaArrotondamentiRecord} from "@commons/mapping/TabellaArrotondamentiRecord";
import {TabellaAlternativiTurniRecord} from "@commons/mapping/TabellaAlternativiTurniRecord";
import {Flex} from "@commons/services/presenze_calcolo/sub_calcolo/Flex";
import {GiuAutomatici} from "@commons/services/presenze_calcolo/sub_calcolo/GiuAutomatici";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {FasciaOrariaWeekRecord} from "@commons/mapping/FasciaOrariaWeekRecord";
import {TolleranzaRecord} from "@commons/mapping/TolleranzaRecord";
import {TabellaGiustAutoRecord} from "@commons/mapping/TabellaGiustAutoRecord";
import {AttestatiINPS} from "@commons/services/presenze_calcolo/sub_calcolo/AttestatiINPS";
import {CausaliWF} from "@commons/services/presenze_calcolo/sub_calcolo/CausaliWF";
import {OreEccedenti} from "@commons/services/presenze_calcolo/sub_calcolo/OreEccedenti";
import {QuantificaEccRecord} from "@commons/mapping/QuantificaEccRecord";
import {SpecificheDiProduzione} from "@commons/services/presenze_calcolo/sub_calcolo/SpecificheDiProduzione";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";
import {IndiceMese, Periodo} from "@commons/types";
import {ConsolidatedData, GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {CachePresenze} from "@commons/mapping/CachePresenze";
import {Accumuli} from "@commons/services/presenze_calcolo/sub_calcolo/Accumuli";
import {RiepilogoGiustificativi} from "@commons/mapping/RiepilogoGiustificativiRecord";
import {CalcoloPresenzeTask} from "@commons/services/presenze_calcolo/sub_calcolo/CalcoloPresenzeTask";
import {cloneDeep} from "lodash";
import {GiustificazioneDiMassaTask} from "@commons/services/presenze_calcolo/sub_calcolo/GiustificazioneDiMassaTask";
import {ManutenzioneTimbrature} from "@commons/mapping/ManutenzioneTimbrature";

const isDevelopment = () => (process.env.NODE_ENV === 'development');

type ForEachDayFun = (giornata: PresenzeGiornataPlusRecord, index: number, weekRif: StatoWeekPLUSRecord | null, soleMesRif: boolean) => void;
type CallbackCalcolo = (day: PresenzeGiornataPlusRecord, impostaPrevistoConESenza: boolean, giornataBloccataConWF: boolean) => void;
export type LavoratoreCalcolo = Pick<LavoratorePresenzeRecord, 'codDip' | 'descrizione' | 'cognome' | 'nome' | 'dataAssunzione' | 'dataCessazione' | 'proprieta' | 'orarioProprieta' | 'status'>;

function hhmm2moment(hhmm: number): DateTime {
    const quotient = Math.floor(hhmm / 100);
    const remainder = hhmm % 100;
    return DateTime.fromObject({hour: quotient, minute: remainder, second: 0, millisecond: 0});
}

interface CalcolaGiornataParams {
    day2calculate: PresenzeGiornataPlusRecord,
    calcolaEffettive?: boolean,
    compensa?: boolean,
    calcoloMassivo?: boolean,
    chiusuraAnticipata?: boolean,
    impostaPrevistoConESenza?: boolean,
    normalizzaSTD?: boolean,
    giornataBloccataConWF?: boolean,
}

interface RiCalcolaGiornataParams extends CalcolaGiornataParams {
    ricalcolo?: boolean,
}


export class Calcolo {

    private readonly gestione: GestionePlusData;
    private readonly cache: CachePresenze;
    private readonly lavoratore: LavoratoreCalcolo;
    //private readonly anno: number;
    //private readonly mese: IndiceMese;

    private readonly days: PresenzeGiornataPlusRecord[] | null;
    private readonly weeks: StatoWeekPLUSRecord[] | null;
    private readonly attestatiINPS;

    // Per costruttori privati e factory puoi vedere:
    // https://stackoverflow.com/questions/51134172/what-is-the-usage-of-private-and-protected-constructors-in-typescript
    private constructor(gestione: GestionePlusData, cache: CachePresenze, lavoratore: LavoratoreCalcolo) {
        this.gestione = gestione;
        this.cache = cache;
        this.lavoratore = lavoratore;
        //this.anno = gestione.anno;
        //this.mese = gestione.mese;
        this.days = gestione.days;
        this.weeks = gestione.weeks;
        GestionePlusData.normalizzaDays(this.gestione);

        this.attestatiINPS = new AttestatiINPS(this.lavoratore,
            gestione.giustificativiAttestati,
            gestione.giustificativiAttestatiElaborati,
            cache);
    }

    static getInstance = (cachePresenze: CachePresenze, lavoratore: LavoratorePresenzeRecord, periodo: Periodo, soloMeseRif: boolean, cloneData: boolean, context?: ConsolidatedData): Calcolo => {
        return new Calcolo({
            anno: periodo.anno,
            mese: periodo.mese,
            soloMeseRif: soloMeseRif,

            days: cloneData ? cloneDeep(lavoratore.days) : lavoratore.days,
            weeks: cloneData ? cloneDeep(lavoratore.weeks) : lavoratore.weeks,
            totaliMese: cloneData ? cloneDeep(lavoratore.totaliMese) : lavoratore.totaliMese,

            proprietaOrario: lavoratore.proprietaOrario,

            causaliWF: cloneData ? cloneDeep(lavoratore.causaliWF) : lavoratore.causaliWF,
            causaliWFElaborate: cloneData ? cloneDeep(lavoratore.causaliWFElaborate) : lavoratore.causaliWFElaborate,
            giustificativiAttestati: cloneData ? cloneDeep(lavoratore.giustificativiAttestati) : lavoratore.giustificativiAttestati,
            giustificativiAttestatiElaborati: cloneData ? cloneDeep(lavoratore.giustificativiAttestatiElaborati) : lavoratore.giustificativiAttestatiElaborati,

            // Aggiorno elenco stati e proprietà di gestione
            elencoStatus: context?.elencoStatus || [],
            proprietaGestione: context?.proprietaGestione || null,

            calendarioChiusure: context?.calendarioChiusure || null,

            elencoTurni: context?.elencoTurni || [],
            turnoAConsuntivo: context?.turnoAConsuntivo || null,

            tabFlex: context?.tabFlex || null,
            tabQualificaEcc: context?.tabQualificaEcc || null,
            tabQuantificaEcc: context?.tabQuantificaEcc || null,
            distribuzioneTurno: context?.distribuzioneTurno || null,

        }, cachePresenze!, lavoratore);
    }

    static getInstanceFromGestione = (gestione: GestionePlusData, cache: CachePresenze, lavoratore: LavoratorePresenzeRecord): Calcolo => {
        return new Calcolo(gestione, cache, lavoratore);
    }

    /**
     * forEachDay esegue la funzione <fun> per tutti i giorni del periodo/mese/settimana
     * @param days
     * @param mese
     * @param fun funzione da eseguire per tutti i giorni del periodo e della settimana indicata in weekRif
     * @param weekRif settimana di riferimento (Week)
     * @param soloMeseRif solo per i giorni del mese di riferimento (boolean)
     * @private
     */
    static forEachDay = (days: PresenzeGiornataPlusRecord[] | null, mese: IndiceMese, fun: ForEachDayFun, weekRif: StatoWeekPLUSRecord | null = null, soloMeseRif: boolean = false) => {
        if (!fun || !days) {
            return;
        }
        for (let day = 0; day < days.length; ++day) {
            const giornata = days[day];
            if (giornata && giornata.totali && (!weekRif || giornata.week === weekRif) && (!soloMeseRif || giornata.mese === mese)) {
                fun(giornata, day, weekRif, soloMeseRif);
            }
        }
    };

    static updateTotaliMese = (gestione: Pick<GestionePlusData, "weeks" | "days" | "mese">,
                               totaliMese: StatoWeekPLUSRecord,
                               soloMeseRif: boolean,
                               cache: CachePresenze,
                               updateAccumuli: boolean = false) => {
        if (totaliMese && gestione.weeks) {
            totaliMese.hired = true;

            RiepilogoOrePlus.clear(totaliMese.totali);
            totaliMese.giustificativi = [];

            for (let iWeek = 0; iWeek < gestione.weeks.length; iWeek++) {		// per sette giorni...
                let week = gestione.weeks[iWeek];
                if (soloMeseRif) {
                    // se devo totalizzare solo i giorni del mese allora utilizzo una istanza appoggio che ricalcolo con soloMeseRif a true!
                    week = StatoWeekPLUSRecord.factory();
                    week.index = gestione.weeks[iWeek].index;
                    week.totali = RiepilogoOrePlus.factory();
                    week.giustificativi = [];
                    StatoWeekPLUSRecord.totalizzaWeek(gestione.days!, cache, week, iWeek, true, gestione.mese);
                }
                if (week !== null && week.totali !== null) {

                    // aggiorno totali ore
                    RiepilogoOrePlus.add(totaliMese.totali, week.totali);

                    // Aggiorno riepilogo giustificativi
                    for (let indGiu = 0; indGiu < week.giustificativi.length; ++indGiu) {
                        const causale = week.giustificativi[indGiu].giustificativo;
                        if (causale) {
                            let riepilogo = StatoWeekPLUSRecord.getRiepilogoGiu(totaliMese, causale.codGiu!);
                            if (riepilogo === null) {
                                const giustificativo = cache.getGiustificativo(causale.codGiu!);
                                riepilogo = new RiepilogoGiustificativi({
                                        giustificativo: giustificativo!,
                                        quantita: 0
                                    }
                                );
                                totaliMese.giustificativi.push(riepilogo);
                            }
                            riepilogo.quantita += week.giustificativi[indGiu].quantita;
                        }
                    }
                }
            }
        }
        if (updateAccumuli) {
            Accumuli.aggiornaSaldiAccumuli({
                ...gestione,
                totaliMese,
                currentWeek: null,
            }, null);
        }
        return totaliMese;
    };

    private static updateTotaliWeek = (gestione: GestionePlusData, week: StatoWeekPLUSRecord, dayRif: PresenzeGiornataPlusRecord, cache: CachePresenze, lavoratore: LavoratoreCalcolo): void => {
        GestionePlusData.updateTotaliWeek(gestione, lavoratore, week, cache);
        Accumuli.aggiornaSaldiAccumuli({
            ...gestione,
            currentWeek: dayRif.week,
        }, dayRif.week, dayRif);
    };

    public setSelected = (days: Pick<PresenzeGiornataPlusRecord, 'dtGiornata'>[]) => {
        days.forEach(({dtGiornata}) => {
            const newDay = this.days!.find(d => d.dtGiornata === dtGiornata);
            if (newDay) {
                newDay.selected = true
            }
        });

    }

    public getGestione = () => this.gestione;
    public setSoloMeseRif = (soloMeseRif: boolean): void => {
        this.gestione.soloMeseRif = soloMeseRif;
    }
    public calcolaGiornata = ({
                                  day2calculate,
                                  calcolaEffettive = false,
                                  compensa = false,
                                  calcoloMassivo = false,
                                  chiusuraAnticipata = false,
                                  impostaPrevistoConESenza = false,
                                  normalizzaSTD = false,
                                  giornataBloccataConWF = false
                              }: CalcolaGiornataParams, consolidatedData?: ConsolidatedData) => {
        const day = this.normalizzaDay(day2calculate);
        const that = this;
        const gestione = this.gestione;
        const week = day.week!;

        gestione.proprietaOrario = consolidatedData?.proprietaOrario || gestione.proprietaOrario;

        gestione.elencoStatus = consolidatedData?.elencoStatus || gestione.elencoStatus;
        gestione.proprietaGestione = consolidatedData?.proprietaGestione || gestione.proprietaGestione;
        gestione.calendarioChiusure = consolidatedData?.calendarioChiusure || gestione.calendarioChiusure;
        gestione.elencoTurni = consolidatedData?.elencoTurni || gestione.elencoTurni;
        gestione.turnoAConsuntivo = consolidatedData?.turnoAConsuntivo || gestione.turnoAConsuntivo;
        gestione.tabFlex = consolidatedData?.tabFlex || gestione.tabFlex;
        gestione.tabQualificaEcc = consolidatedData?.tabQualificaEcc || gestione.tabQualificaEcc;
        gestione.tabQuantificaEcc = consolidatedData?.tabQuantificaEcc || gestione.tabQuantificaEcc;
        gestione.distribuzioneTurno = consolidatedData?.distribuzioneTurno || gestione.distribuzioneTurno;

        if (!gestione.proprietaGestione || !that.lavoratore) return;
        if (gestione.proprietaGestione.quantitaTimbrature === "A_CONSUNTIVO") {
            /**
             * Il calcolo a consuntivo si compone di 4 fasi:
             * 0: reset totale ore ordinarie (diurne/notturne) a eccezione dei giorni con previsto manuale e festivi
             * 1: calcolo dei giorni della settimana fino al giorno corrente (escluso)
             * 2: calcolo del corrente
             * 3: calcolo dei giorni della settimana successivi al giorno corrente
             */
            this._forEachDay((giornata, _indexGiornata, _weekRif, _soloMeseRif) => {
                // fase 0:
                // Resetto contatore ore ordinarie per intera settimana in modo da poterle ricalcolare nelle fasi successive
                if (!giornata.giornataBloccata && giornata.previsteLocked && !giornata.festivo) {
                    giornata.totali!.hOrdDiurne = 0;
                    giornata.totali!.hOrdNotturne = 0;
                }
            }, week, false);

            // fase 1:
            // Calcolo dei giorni della settimana fino al giorno corrente (escluso)
            this._forEachDay(function (giornata, _indexGiornata, _weekRif, _soloMeseRif) {
                // Calcolo fino al giorno corrente
                if (!giornata.giornataBloccata && DateTime.fromISO(giornata.dtGiornata!) < DateTime.fromISO(day.dtGiornata!)) {
                    console.log("Fase 1: calcolo il", GestionePlus.formatDate(giornata.dtGiornata));
                    // Imposto turno corrente
                    if (!giornata.currentTurno) {
                        giornata.currentTurno = that.getTurno(giornata.codTurno);
                    }
                    gestione.elencoStatus = LavoratorePresenzeRecord.getStatus(that.lavoratore, giornata.dtGiornata);
                    that._calcolaGiornata({
                        day2calculate: giornata,
                        calcolaEffettive: giornata.arrotondateLocked,
                        compensa: false,
                        calcoloMassivo: true,
                        chiusuraAnticipata: false,
                        impostaPrevistoConESenza: false
                    });
                }
            }, week, false);
        }

        // fase 2 per calcolo a consuntivo e calcolo ordinario
        if (gestione.proprietaGestione.quantitaTimbrature === "A_CONSUNTIVO") {
            console.log("Fase 2/calcolo ordinario: calcolo il", GestionePlus.formatDate(day.dtGiornata));

            // ripristino elencoStatus giornata corrente
            gestione.elencoStatus = LavoratorePresenzeRecord.getStatus(that.lavoratore, day.dtGiornata);
        } else {
            console.log("Calcolo ordinario: calcolo il", GestionePlus.formatDate(day.dtGiornata));
        }

        this._calcolaGiornata({
            day2calculate: day,
            calcolaEffettive: calcolaEffettive,
            compensa: compensa,
            calcoloMassivo: calcoloMassivo,
            chiusuraAnticipata: chiusuraAnticipata,
            impostaPrevistoConESenza: impostaPrevistoConESenza,
            normalizzaSTD: normalizzaSTD,
            giornataBloccataConWF: giornataBloccataConWF
        });

        // fase 3:
        // Calcolo dei giorni della settimana successivi al giorno corrente
        if (gestione.proprietaGestione.quantitaTimbrature === "A_CONSUNTIVO") {

            this._forEachDay(function (giornata, _indexGiornata, _weekRif, _soloMeseRif) {
                // Calcolo dal giorno successivo al giorno corrente
                if (!giornata.giornataBloccata && DateTime.fromISO(giornata.dtGiornata!) > DateTime.fromISO(day.dtGiornata!)) {
                    console.log("Fase 3: calcolo il", GestionePlus.formatDate(giornata.dtGiornata));
                    // Imposto turno corrente
                    if (giornata.currentTurno === null) {
                        giornata.currentTurno = that.getTurno(giornata.codTurno);
                    }
                    gestione.elencoStatus = LavoratorePresenzeRecord.getStatus(that.lavoratore, giornata.dtGiornata);
                    that._calcolaGiornata({
                        day2calculate: giornata,
                        calcolaEffettive: giornata.arrotondateLocked,
                        compensa: false,
                        calcoloMassivo: true,
                        chiusuraAnticipata: false,
                        impostaPrevistoConESenza: false
                    });
                }
            }, week, false);

            if (!calcoloMassivo) {
                Calcolo.updateTotaliWeek(gestione, week, day, that.cache, that.lavoratore);
                Calcolo.updateTotaliMese(gestione, gestione.totaliMese!, gestione.soloMeseRif, that.cache, true);
            }
        } else {
            if ((day.anomalia === 0) && !calcoloMassivo) {
                Calcolo.updateTotaliWeek(gestione, week, day, that.cache, that.lavoratore);
                Calcolo.updateTotaliMese(gestione, gestione.totaliMese!, gestione.soloMeseRif, that.cache, true);
            }
        }

        // Verifica criteri per "Accumuli di controllo"
        if (day.anomalia === 0 && gestione.totaliMese!.accumuliCHK) {
            for (let indCHK = 0; indCHK < gestione.totaliMese!.accumuliCHK.length; ++indCHK) {
                const accumulo = gestione.totaliMese!.accumuliCHK[indCHK];
                // effettuo il controllo solo se la giornata utilizza almeno un giustificativo interessato dall'accumulo
                const applicaControllo = AccumuloRecord.hasGiuAccumulo(accumulo, day);
                if (applicaControllo) {
                    let saldoPeriodo = accumulo.saldoIniziale;
                    const calcolaSaldo = (giornata: PresenzeGiornataPlusRecord, indexGiornata: number, weekRif: StatoWeekPLUSRecord | null, soloMeseRif: boolean) => {
                        saldoPeriodo += AccumuloRecord._calcolaSaldo(accumulo, day, giornata, indexGiornata, weekRif, soloMeseRif);
                    };
                    if (accumulo.periodo === "SETTIMANA") {
                        this._forEachDay(calcolaSaldo, day.week, false);
                    } else if (accumulo.periodo === "GIORNO") {
                        saldoPeriodo = AccumuloRecord._calcolaSaldo(accumulo, day, day, 0, null, false);
                    } else {
                        this._forEachDay(calcolaSaldo, null, true);
                    }
                    if (AccumuloRecord.applicaCriterio(accumulo, saldoPeriodo, day.totali!)) {
                        if (accumulo.tipoCheckPresenze === "WARNING") {
                            PresenzeGiornataPlusRecord.setWarning(day, 2048);
                            break;
                        } else if (accumulo.tipoCheckPresenze === "ERROR") {
                            //day.anomalia = 21; Rimosso il 18/02/2022, non potendo resettare se saldo fine mese corretto
                            break;
                        }
                    }
                }
            }
        }
        // 02/05/2024: la chiamata è stata spostata in gestione...
        //gestione.allineaIstituti();
    };

    public calcolaInteroPeriodo = (callback: CallbackCalcolo, task?: CalcoloPresenzeTask): void => {
        const interattivo = task ? false : true;
        const elaboraGiorniBloccati = interattivo ? false : task!.elaboraGiorniBloccati;
        const elaboraGiorniBloccatiSeWF = interattivo ? false : task!.elaboraGiorniBloccatiSeWF;
        const impostaPrevistoConESenza = interattivo ? false : task!.impostaPrevistoConESenza;
        const livelloPresenzeChiusura = task ? task.livelloPresenzeChiusura : 1; // senza task, calcola solo se giornata aperta!
        const lavoratore = this.lavoratore;
        const days = this.days;
        const gestione = this.gestione;
        if (lavoratore && days) {
            console.log("Calcolo intero periodo!");
            for (let ind0 = 0; ind0 < days.length; ++ind0) {
                const day = days[ind0];
                if ((interattivo && day.mese === gestione.mese) || (!interattivo && CalcoloPresenzeTask.IsBetweenDate(task!, day.dtGiornata))) {
                    if (LavoratorePresenzeRecord.isPresenteIl(lavoratore, day.dtGiornata)) {

                        const dayHasAttestato = this.attestatiINPS.hasAttestato4day(day);
                        // Sblocco giornata se c'e' un certificato e se giornata...
                        if (day.giornataBloccata) {
                            if (dayHasAttestato.hasAttestato && dayHasAttestato.posCausaleMT === -1) {
                                if (RiepilogoOrePlus.getTotaleHPrev(day.totali) === 0 && // senza previsto
                                    RiepilogoOrePlus.getTotaleHLav(day.totali) === 0 && // senza lavorato
                                    (!day.causaliHH || day.causaliHH.length === 0 || !PresenzeGiustificativo.isValid(day.causaliHH[0]))) { // senza giustificativi
                                    day.giornataBloccata = false; // N.B. sul database la giornata rimane chiusa! L'operazione massiva non DEVE modificare tale flag!
                                }
                            }
                        }

                        // Salvo stato originale per successive valutazioni in caricamento richieste di WF
                        // N.B. il controllo precedente su eventuali attestati di malattia, potrebbero aver gia modificato lo stato della giornata
                        const giornataBloccata = day.giornataBloccata;
                        // Sblocco giornata se c'e' almeno una causale da WF da elaborare
                        if (elaboraGiorniBloccatiSeWF && day.giornataBloccata && gestione.causaliWF) {
                            for (let indCausale = 0; indCausale < gestione.causaliWF.length; ++indCausale) {
                                const causaleWF = gestione.causaliWF[indCausale];
                                if (!causaleWF.elaborato
                                    && causaleWF.giornoDt === day.dtGiornata
                                    && gestione.causaliWFElaborate.findIndex(key => key === PresenzeCausaleWFRecord.getKey(causaleWF)) === -1) {
                                    day.giornataBloccata = false; // N.B. sul database la giornata rimane chiusa! L'operazione massiva non DEVE modificare tale flag!
                                }
                            }
                        }

                        if (day.stato < livelloPresenzeChiusura
                            && (day.giornataBloccata === false || elaboraGiorniBloccati || (dayHasAttestato.posCausaleMT >= 0))) {

                            if (impostaPrevistoConESenza) {
                                day.tipoRilevazione = 'MANUALE';
                            }
                            callback(day, impostaPrevistoConESenza, giornataBloccata && elaboraGiorniBloccatiSeWF);
                        }
                    }
                }
            }
        }
    };

    /**
     * Giustificazione di massa
     * N.B. se chiamata dalla pagina plus verranno gestite solo le giornate "PLUS",
     * se chiamata dalla pagina STD2 verranno gestite solo le giornate "MANUALE",
     */
    public giustificazioneMassa = (gm: GiustificazioneDiMassaTask,
                                   isPaginaPlus: boolean,
                                   soloMeseRif: boolean,
                                   interattivo: boolean): PresenzeGiornataPlusRecord[] => {
        console.log("Giustifica periodo!");
        this.setSoloMeseRif(soloMeseRif);
        const lavoratore = this.lavoratore;
        const days = this.days!;
        const results: PresenzeGiornataPlusRecord[] = [];
        for (let ind0 = 0; ind0 < days.length; ++ind0) {
            const day = days[ind0];
            if ((interattivo && day.selected) || GiustificazioneDiMassaTask.IsBetweenDate(gm, day.dtGiornata)) {
                day.selected = false;
                if (!interattivo || (isPaginaPlus && day.tipoRilevazione !== 'MANUALE') || (!isPaginaPlus && day.tipoRilevazione === 'MANUALE')) {
                    if (!GestionePlus.isFuoriSede(day, {
                        idAzienda: gm.idAzienda!,
                        idAziendaMaster: gm.idAziendaMaster!
                    }) && GiustificazioneDiMassaTask.isGMCompliance(gm, day, this.lavoratore)) {

                        const {consolidatedData, calcolabile} = GestionePlusData.consolidaGiornata(gm as Periodo, lavoratore, day, this.cache, false, true);

                        let giustifica = false;
                        if (gm.controllaIntervalloLavorato) {
                            giustifica = GiustificazioneDiMassaTask.isPresenteDalleAlle(gm, day);
                        } else {
                            giustifica = true;
                        }

                        if (giustifica) {
                            //var orePreviste = giornata.totali.hPrevDiurne + giornata.totali.hPrevNotturne;
                            //if ((orePreviste === 0) && (this.proprietaGestione.quantitaTimbrature === 'A_CONSUNTIVO')) {
                            if ((gm.tipoOperazione === 'INSERIMENTO') && (day.previsteLocked) && (consolidatedData.proprietaGestione?.quantitaTimbrature === 'A_CONSUNTIVO')) {
                                GestionePlus.allineaPrevisto(day, consolidatedData.elencoTurni[0], true, consolidatedData.elencoTurni);
                                day.previsteLocked = false;
                            }
                            if (GiustificazioneDiMassaTask.calcolarePrimaDiGiustificare(gm, day, consolidatedData, this.cache) && calcolabile) {
                                this.calcolaGiornata({
                                    day2calculate: day,
                                    calcolaEffettive: day.arrotondateLocked,
                                    compensa: false,
                                    calcoloMassivo: true,
                                    impostaPrevistoConESenza: false,
                                    giornataBloccataConWF: false
                                }, consolidatedData);
                            }

                            GiustificazioneDiMassaTask.giustificazioneMassaDay(gm, day, this.gestione, this.cache, interattivo);

                            if (gm.calcolaPresenze && calcolabile) {
                                this.calcolaGiornata({
                                    day2calculate: day,
                                    calcolaEffettive: day.arrotondateLocked,
                                    compensa: false,
                                    calcoloMassivo: true,
                                    impostaPrevistoConESenza: false,
                                    giornataBloccataConWF: false
                                }, consolidatedData);
                            } else {
                                PresenzeGiornataPlusRecord.resetAnomalia(day);
                            }
                            results.push(day);
                            //gestione.consolidaModifiche(giornata);
                        }
                    }
                }
            }
        }

        /*if (interattivo) {
            gestione.terminaGM(true);
        }*/
        return results;
    }

    private normalizzaDay = (day: PresenzeGiornataPlusRecord): PresenzeGiornataPlusRecord => {
        if (this.days) {
            const day2Calculate = day;
            const index = this.days.findIndex((day: PresenzeGiornataPlusRecord) => day.dtGiornata === day2Calculate.dtGiornata);
            if (index >= 0) {
                this.days[index] = day2Calculate;
                GestionePlusData.normalizzaDays(this.gestione);
                return day2Calculate;
            }
        }
        throw new Error("Index Out of Bounds");
    }

    private getTurno = (codTurno: number) => this.cache.getTurno(codTurno);

    /**
     * Se sussiste la pausa flex allora valido le timbrature arrotondate
     * N.B. Utile solo se è l'utente a inserire manualmente le timbrature, altrimenti il controllo è inutile
     * Non ho vincolato la verifica al flag arrotondateLocked perché l'utente potrebbe modificare le timbrature, ribloccare le timbrature, quindi F2... (todo da migliorare)
     * @param day
     * @param distribuzione
     */
    private validaArrotondate = (day: PresenzeGiornataPlusRecord, distribuzione: TurnoDistribuzioneRecord) => {
        if (day.arrotondate.length > 0) {
            const pausa = CoppiaTimbrature.factory();
            const timbPausaFlex = this.rilevaTimbPausa(day.arrotondate, distribuzione, pausa);
            // Solo se ho una sola copia di timbrature nella fascia della pausa flex posso valutare la correttezza delle timbrature arrotondate
            if (timbPausaFlex.length === 2) {
                const coppiaPausa = new Coppia(pausa);
                const durataPausaTotale = coppiaPausa.calc.getCount();
                const result = this.adattaPrevistoSuPausa(day, pausa, distribuzione, true); // N.B. adattaPrevistoSuPausa aggiorna day.durataPausa!!!
                if (durataPausaTotale !== (day.durataPausa + result.mancanteExtra)) {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 12);
                    console.error("Anomalia: " + PresenzeGiornataPlusRecord.getDescrizioneAnomalia(day));
                }
            } else {
                PresenzeGiornataPlusRecord.setAnomalia(day, 12);
                console.error("Anomalia: " + PresenzeGiornataPlusRecord.getDescrizioneAnomalia(day));
            }
        }
    };

    /**
     * Rilevo la prima copia utile di timbrature (entrata e uscita) compresa nell'intervallo dedicato alla pausa flex
     * Eventuali altre copie non sono significative, ed eventualmente andranno a generare un mancante!
     * @param origine
     * @param distribuzione
     * @param coppiaPausa la copia di timbrature rappresentante la pausa
     * @returns Array di number con le posizioni in cui sono presenti le 2 timbrature interessate alla pausa flex
     */
    private rilevaTimbPausa = (origine: CoppiaTimbrature[], distribuzione: TurnoDistribuzioneRecord, coppiaPausa?: CoppiaTimbrature): number[] => {
        const timbPausaFlex: number[] = []; // zero based
        if (origine.length > 0 && distribuzione.pausa) { // cerco timbrature in fascia pausa
            let indexTimb = 0;
            for (let indE = 0; indE < origine.length && timbPausaFlex.length < 2; ++indE) {
                let timbratura;
                // uscita pausa
                timbratura = origine[indE].entrata;
                if (CoppiaTimbrature.contains(distribuzione.pausa, timbratura) && timbPausaFlex.length > 0) {
                    timbPausaFlex.push(indexTimb);
                    if (coppiaPausa) {
                        CoppiaTimbrature.setUscita(coppiaPausa, timbratura);
                    }
                }
                ++indexTimb;
                // entrata pausa
                if (timbPausaFlex.length < 2) {
                    timbratura = origine[indE].uscita;
                    if (CoppiaTimbrature.contains(distribuzione.pausa, timbratura)) {
                        timbPausaFlex.push(indexTimb);
                        if (coppiaPausa) {
                            CoppiaTimbrature.setEntrata(coppiaPausa, timbratura);
                        }
                    }
                }
                ++indexTimb;
            }
        }
        return timbPausaFlex;
    };

    /**
     * Verifica la durata della pausa, modificando sia il fine pausa sia adeguando il previsto alla durata della pausa stessa
     * @param day
     * @param pausa
     * @param distribuzione
     * @param settaAnomalia
     * @returns {} un oggetto con il risultato dell'elaborazione:
     * offset: l'eventuale offset di arrotondamento determinato dalla durata della pausa.
     * durata: la durata fino a distribuzione.maxMinutiPausa
     * mancanteExtra: la durata oltre a distribuzione.maxMinutiPausa
     */
    private adattaPrevistoSuPausa = (day: PresenzeGiornataPlusRecord, pausa: CoppiaTimbrature, distribuzione: TurnoDistribuzioneRecord, settaAnomalia: boolean): {
        offset: number | null,
        durata: number | null,
        mancanteExtra: number
    } => {
        const posticipaUscita = (day: PresenzeGiornataPlusRecord, durata: number, minimo: number) => {
            day.durataPausa = durata;
            let uscita = CoppiaTimbrature.getUscita(day.previste[day.previste.length - 1]);
            uscita = Calc.hhmm2hhcc(uscita);
            uscita += Calc.hhmm2hhcc(durata - minimo);
            uscita = Calc.hhcc2hhmm(uscita);
            CoppiaTimbrature.setUscita(day.previste[day.previste.length - 1], uscita);
        };

        const result: {
            offset: number | null,
            durata: number | null,
            mancanteExtra: number
        } = {offset: null, durata: null, mancanteExtra: 0};
        const copiaPausa = new Coppia(pausa);
        let durataPausa = copiaPausa.calc.getCount();
        //console.log('Durata pausa: ', durataPausa);
        if (durataPausa <= distribuzione.maxMinutiPausa) {
            let minimo = distribuzione.minMinutiPausa;
            while (minimo <= distribuzione.maxMinutiPausa) {
                if (durataPausa <= minimo) {
                    const hhccDurata = (minimo / 60) * 100.0;
                    let hhccEntrata = Calc.hhmm2hhcc(CoppiaTimbrature.getEntrata(pausa));
                    hhccEntrata += hhccDurata;
                    hhccEntrata = Math.round(hhccEntrata); // Modifica del 2/8/2019
                    CoppiaTimbrature.setUscita(pausa, Calc.hhcc2hhmm(hhccEntrata));
                    break;
                }
                if (distribuzione.incrementoPausa === 0) {
                    break;
                }
                minimo += distribuzione.incrementoPausa;
            }

            // modifico previsto per adeguare l'uscita alla durata della pausa (piu' lunga...)
            posticipaUscita(day, minimo, distribuzione.minMinutiPausa);

        } else {
            posticipaUscita(day, distribuzione.maxMinutiPausa, distribuzione.minMinutiPausa);
            const newDurata = durataPausa - distribuzione.maxMinutiPausa;
            // Arrotondo al quarto d'ora in eccesso!
            const divisore = TurnoDistribuzioneRecord.getMinArrotondamentoPausa(distribuzione);
            let scarto = Math.ceil(newDurata / divisore);
            scarto *= divisore;
            durataPausa = distribuzione.maxMinutiPausa + scarto;
            const hhccDurata = (durataPausa / 60) * 100.0;
            let hhccEntrata = Calc.hhmm2hhcc(CoppiaTimbrature.getEntrata(pausa));
            hhccEntrata += hhccDurata;
            CoppiaTimbrature.setUscita(pausa, Calc.hhcc2hhmm(hhccEntrata));

            if (settaAnomalia) {
                PresenzeGiornataPlusRecord.setWarning(day, 4);
                console.warn("Warning: " + PresenzeGiornataPlusRecord.getDescrizioneWarning(4));
            }

            result.durata = distribuzione.maxMinutiPausa;
            result.mancanteExtra = scarto;
        }

        // Fisso eventuale offset di arrotondamento!
        // Vedi es. 50'...
        if (distribuzione.minMinutiPausa === 50) {
            result.offset = 10; // todo generalizzare!!!
        } else {
            result.offset = 0;
        }

        return result;
    };

    private aggiornaSaldiAccumuli = (day: PresenzeGiornataPlusRecord) => {
        Accumuli.aggiornaSaldiAccumuli({
            ...this.gestione,
            currentWeek: day.week
        }, null, null);
    };

    private _calcolaGiornata = (params: RiCalcolaGiornataParams) => {
        const {
            day2calculate: day,
            calcolaEffettive = false,
            compensa = false,
            calcoloMassivo = false,
            chiusuraAnticipata = false,
            impostaPrevistoConESenza: impostaPrevistoDaDistribuzione = false,
            normalizzaSTD = false,
            giornataBloccataConWF = false, // Se true significa che in origine la giornata era bloccata, è in fase di calcolo perché l'utente ha forzato il calcolo delle giornate bloccate con causali di WF da elaborare!
            ricalcolo = false
        } = params;

        if (isDevelopment()) {
            console.log('dtGiornata', day.dtGiornata);
            console.log('calcolaEffettive', calcolaEffettive);
            console.log('compensa', compensa);
            console.log('calcoloMassivo', calcoloMassivo);
            console.log('chiusuraAnticipata', chiusuraAnticipata);
            console.log('impostaPrevistoDaDistribuzione', impostaPrevistoDaDistribuzione);
            console.log('normalizzaSTD', normalizzaSTD);
            console.log('giornataBloccataConWF', giornataBloccataConWF);
            console.log('ricalcolo', ricalcolo);
        }

        const that = this;
        const gestione = this.gestione;
        const cache = this.cache;
        const lavoratore = that.lavoratore;
        let nextRicalcolo = false; // viene impostato a true solo nel caso di ricalcolo dell'intera giornata dovuto a intervento causale da WF per lavoratori con "timbrature di sola presenza"

        const normalizzaPrevisto = (distribuzioneSorgente: TurnoDistribuzioneRecord, hhPreviste: number): TurnoDistribuzioneRecord => {
            const distribuzioneTarget = TurnoDistribuzioneRecord.factory();
            distribuzioneTarget.idAziendaTabelle = distribuzioneSorgente.idAziendaTabelle;
            distribuzioneTarget.codTurno = distribuzioneSorgente.codTurno;
            distribuzioneTarget.idGiorno = distribuzioneSorgente.idGiorno;
            distribuzioneTarget.descrizione = distribuzioneSorgente.descrizione;
            distribuzioneTarget.descrizioneTurno = distribuzioneSorgente.descrizioneTurno;
            distribuzioneTarget.hhPreviste = distribuzioneSorgente.hhPreviste;
            distribuzioneTarget.previstoModificabile = distribuzioneSorgente.previstoModificabile; // boolean
            distribuzioneTarget.sestoGiorno = distribuzioneSorgente.sestoGiorno; // boolean
            distribuzioneTarget.settimoGiorno = distribuzioneSorgente.settimoGiorno; // boolean
            if (hhPreviste > 0) {
                distribuzioneTarget.prima = CoppiaTimbrature.factory();
                CoppiaTimbrature.setEntrata(distribuzioneTarget.prima, 0);
                CoppiaTimbrature.setUscita(distribuzioneTarget.prima, Calc.hhcc2hhmm(hhPreviste * 100));
            }
            return distribuzioneTarget;
        };

        if (!calcoloMassivo) {
            console.log(LavoratorePresenzeRecord.getDescrizione(lavoratore), GestionePlus.formatDate(day.dtGiornata), "Calcolo giornata da", calcolaEffettive ? "EFFETTIVE" : "ARROTONDATE");
        }

        if (!normalizzaSTD) {
            //gestione.setModified(day); // todo da verificare!
            day.modified = true;
        }
        PresenzeGiornataPlusRecord.resetAnomalia(day, ricalcolo);
        if (gestione.proprietaGestione === null) {
            PresenzeGiornataPlusRecord.setAnomalia(day, 10);
            return;
        }

        const dayOfWeek = PresenzeGiornataPlusRecord.getDayOfWeek(day);

        let turno = calcolaEffettive ?
            that.getTurno(day.codTurnoPianificazione > 0 ? day.codTurnoPianificazione : day.codTurnoSviluppo) :
            that.getTurno(day.codTurno);

        const index = day.idGiorno;
        let distribuzione;
        if (day.tipoRilevazione === "MANUALE" && !impostaPrevistoDaDistribuzione) {
            distribuzione = normalizzaPrevisto(TurnoRecord.getDistribuzione(turno!, index), RiepilogoOrePlus.getTotaleHPrev(day.totali) / 60);
            PresenzeGiornataPlusRecord.ripristinaPrevisto(day, distribuzione, ricalcolo);
        } else {
            const firstOne = gestione.elencoTurni[0];
            distribuzione = TurnoRecord.getDistribuzione(turno!, index, TurnoRecord.getDistribuzione(firstOne, index));
        }

        let tabelle = LavoratorePresenzeProprietaULRecord.getTabelle(gestione.proprietaGestione, turno!);

        gestione.tabFlex = cache.getTabellaFlex(tabelle.idTabFlex);
        if (day.previsteLocked) {
            PresenzeGiornataPlusRecord.ripristinaPrevisto(day, distribuzione, ricalcolo);
            day.durataPausa = distribuzione.minMinutiPausa;
        } else {
            day.durataPausa = 0;
        }
        day.pausaInTolleranza = {ritardo: 0, mancante: 0, valid: false};

        // Se ricalcolo per rilevazione manuale (giustificazione automatica o da status) non calcolo effettive!
        const skipXRicalcoloSTD = ricalcolo && (day.tipoRilevazione === "MANUALE");

        if (!skipXRicalcoloSTD && calcolaEffettive) {
            day.pausaFlex = day.durataPausa > 0;

            // Primissima cosa: resetto arrotondate!
            //day.eraseTimbrature(day.arrotondate);
            day.arrotondate = [];

            // Applica richiesta Manutenzione Timbrature
            const causaleWF = GestionePlusData.getCausaleWF_MT(gestione, day);
            if (causaleWF) {
                if (causaleWF.wf.stato === 'ACCETTATA') {
                    const key = PresenzeCausaleWFRecord.getKey(causaleWF);
                    const MT = ManutenzioneTimbrature.factory();
                    ManutenzioneTimbrature.ripristinaDaRichiesta(MT, causaleWF);
                    if (ManutenzioneTimbrature.effettiveOriginaliIsChanged(MT, day)) {
                        PresenzeGiornataPlusRecord.setWarning(day, 65536);
                    }
                    if (!causaleWF.elaborato && !gestione.causaliWFElaborate.includes(key)) {
                        day.idWF = causaleWF.wf.idWF;
                        day.maskEffettive = 65535;
                        day.effettiveOriginali = [];
                        day.effettive = [];
                        day.effettiveManualiFlat = [];
                        MT.arrayCoppie.forEach(function (val, index) {
                            const clone = CoppiaTimbrature.factory(val[0]);
                            if ((MT.maskEffettive[index] & 0x01) === 0) {
                                clone.entrata = null;
                            }
                            if ((MT.maskEffettive[index] & 0x02) === 0) {
                                clone.uscita = null;
                            }
                            const entrataIsValid = clone.entrata !== null && clone.entrata.length === 4;
                            const uscitaIsValid = clone.uscita !== null && clone.uscita.length === 4;
                            if (entrataIsValid || uscitaIsValid) {
                                clone.entrataTerminale = '*WF';
                                clone.uscitaTerminale = '*WF';
                                day.effettiveOriginali.push(clone);
                                day.effettive.push(clone);

                                day.effettiveManualiFlat.push(null); // per entrata e per...
                                day.effettiveManualiFlat.push(null); // ... uscita
                            }
                        });
                        gestione.causaliWFElaborate.push(key);
                    }
                }
            }


            day.effettive = Timbrature.defragStrisciata(day.effettive);

            let calcolaArr = true;

            if (!this.isValidTimbEffettive(day)) {
                PresenzeGiornataPlusRecord.setAnomalia(day, -1);
                calcolaArr = false;
            }

            // CALCOLO ARROTONDATE *** INIZIO ***
            if (calcolaArr) {
                //var result = day.analizzaStrisciata(day.effettive); // commentato il 27/5/2020

                let setPrevisto = false;
                const quantitaTimbrature = gestione.proprietaGestione.quantitaTimbrature;
                if (quantitaTimbrature === "COME_DA_ORARIO" || quantitaTimbrature === "A_CONSUNTIVO") {
                    if (chiusuraAnticipata) {
                        // Modalità chiusura anticipata del mese (esempio paghe di luglio e agosto "tutti in ferie")
                        setPrevisto = (day.effettive.length === 0); // Solo se NON vi sono timbrature, altrimenti "non imposto le previste" e calcolo normalmente la giornata
                    }

                    if (calcolaArr && !setPrevisto) {
                        if (gestione.tabFlex !== null && gestione.tabFlex.abilitaFlex && gestione.tabFlex.regolaFlex !== "ADEGUA_USCITA") {
                            const flexEffettive: CoppiaTimbrature[] = this.applicaFlex(day, gestione.tabFlex, calcoloMassivo);
                            this.arrotonda(day, flexEffettive, tabelle, gestione.tabFlex);
                        } else {
                            this.arrotonda(day, day.effettive, tabelle, gestione.tabFlex);
                        }
                        // Aggiorno distribuzione che l'arrotondamento puo' aver cambiato!
                        const turnoPrecedente = turno;
                        turno = that.getTurno(day.codTurno);
                        //index = day.idGiorno; commentato il 17/12/21
                        //distribuzione = turno.getDistribuzione(index); commentato il 17/12/21
                        tabelle = LavoratorePresenzeProprietaULRecord.getTabelle(gestione.proprietaGestione, turno!);
                        if (tabelle.idTabFlex > 0 && turnoPrecedente !== turno) { // Se è stato applicato un turno alternativo, valuto se riapplicare la flex
                            gestione.tabFlex = cache.getTabellaFlex(tabelle.idTabFlex);

                            if (gestione.tabFlex !== null) {
                                if (gestione.tabFlex.abilitaFlex && gestione.tabFlex.regolaFlex !== "ADEGUA_USCITA") { // Solo per flex "legacy"
                                    const flexEffettive: CoppiaTimbrature[] = this.applicaFlex(day, gestione.tabFlex, calcoloMassivo);
                                    this._arrotonda(day, flexEffettive); // Chiamo _arrotonda() e non arrotonda() per evitare di riapplicare gli alternativi!
                                }
                                if (!gestione.tabFlex.abilitaFlex) { // Se disabilitata ricalcolo arrotondate!
                                    this._arrotonda(day, day.effettive);
                                }
                            }
                        }
                    }
                }

                // Fino al 23/11/2023
                //if (setPrevisto || impostaPrevistoConESenza) {
                if (setPrevisto) {
                    day.pausaFlex = false;
                    day.arrotondate = [];
                    PresenzeGiornataPlusRecord.copy(day, day.arrotondate, day.previste);
                }
            }
            // CALCOLO ARROTONDATE *** FINE ***
        } else {
            day.arrotondate = Timbrature.defragStrisciata(day.arrotondate);
            if (Timbrature.analizzaStrisciata(day.arrotondate).isValid()) {
                // Se le previste sono automatiche (non manuali) allora valido le timbrature arrotondate (sempre nel caso di pausa flex)
                if (day.pausaFlex && day.durataPausa > 0 && day.previsteLocked) {
                    this.validaArrotondate(day, distribuzione);
                }
            } else {
                PresenzeGiornataPlusRecord.setAnomalia(day, 12);
                console.error("Anomalia: " + PresenzeGiornataPlusRecord.getDescrizioneAnomalia(day));
            }
        }

        // Aggiorno distribuzioneTurno per log...
        if (day.tipoRilevazione === "MANUALE" && !impostaPrevistoDaDistribuzione) {
            gestione.distribuzioneTurno = normalizzaPrevisto(TurnoRecord.getDistribuzione(turno!, day.idGiorno), RiepilogoOrePlus.getTotaleHPrev(day.totali) / 60);
        } else {
            gestione.distribuzioneTurno = TurnoRecord.getDistribuzione(turno!, day.idGiorno, TurnoRecord.getDistribuzione(gestione.elencoTurni[0], day.idGiorno));
        }
        distribuzione = gestione.distribuzioneTurno;

        let arrotondateAdeguate = false;
        const quantitaTimbrature = gestione.proprietaGestione.quantitaTimbrature;
        switch (quantitaTimbrature) {
            case "COME_DA_ORARIO":
                // Se presente pausa flex, ma l'utente l'ha disattivata, allora copio nel previsto la pausa minima convenzionale
                if (!day.pausaFlex && day.durataPausa > 0) {
                    day.previste = this.impostaPausa(day.previste, distribuzione);
                }
                break;

            case "A_CONSUNTIVO":
                this.consuntivaOre(day);
                break;

            case "UNA":	// Una timbratura
            case "DUE":	// Due timbrature
            case "DUE_ENTRATE":	// Due timbrature (solo in entrata)
            case "CON_O_SENZA":	// Con o senza timbrature
                if (day.arrotondateLocked) {
                    if (day.tipoRilevazione === "MANUALE" && !ricalcolo) {
                        // Rimuovo tutti i giustificativi automatici eventualmente inseriti in precedenza per garantire una corretta valorizzazione delle arrotondate!
                        // tra un calcolo e l'altro possono intervenire modifiche al sistema di giustificazione automatica (status e giu auto)
                        GiuAutomatici.cancelloGiuAutomatici(cache, day, null, true);
                        that.aggiornaSaldiAccumuli(day);
                    }

                    if (!day.pausaFlex && day.durataPausa > 0) {
                        day.previste = this.impostaPausa(day.previste, distribuzione);
                        PresenzeGiornataPlusRecord.copyPrevisto(day); // Copia previsto in arrotondate!
                    }

                    this.adeguaArrotondate(day);
                    arrotondateAdeguate = true;
                }
                break;
        }

        // Verifico se NON ho timbrature effettive e sono presenti giustificativi per ore eccedenti da WF
        if (!arrotondateAdeguate && day.effettive.length === 0 && day.arrotondateLocked) {
            let adeguaArrotondate = false;
            // Cerco causale per eccedente da WF
            for (let indGiuHH = 0; indGiuHH < day.causaliHH.length; ++indGiuHH) {
                const causale = day.causaliHH[indGiuHH];
                if (causale) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu !== null) {
                        if (GiustificativoRecord.isEccedente(giu)) {
                            if (causale.idWF > 0) {
                                adeguaArrotondate = true;
                                break;
                            }
                        }
                    }
                }
            }
            if (adeguaArrotondate) {
                this.adeguaArrotondate(day);
            }
        }

        // Aggiorno fasce per determinazione lavoro diurno/notturno
        const tabFasciaDiurna = cache.getTabellaFasceOrarie(tabelle.idTabFasciaDiurna);
        let fasciaDiurna;
        if (day.tipoRilevazione === "MANUALE") { //  && tabFasciaDiurna === null
            // Se rilevazione manuale e tabella assente imposto default 0-24 (tutto diurno!!!)
            fasciaDiurna = new Coppia(0, 2400);
        } else {
            fasciaDiurna = FasciaOrariaWeekRecord.getCoppia(tabFasciaDiurna!, dayOfWeek);
        }
        const cFasciaDiurna = fasciaDiurna.calc;
        const cFasciaNotturna = cFasciaDiurna.invert();

        // *******************************
        // CALCOLO PREVISTO *** INIZIO ***
        const calcPrevistoD = new Calc();
        const calcPrevistoN = new Calc();
        const copiePreviste = PresenzeGiornataPlusRecord.getCopiePreviste(day);
        day.totali!.hPrevDiurne = 0;
        day.totali!.hPrevNotturne = 0;
        for (let ind0 = 0; ind0 < copiePreviste.length; ++ind0) {
            calcPrevistoD.add(copiePreviste[ind0].calc.getFlat(cFasciaDiurna));
            calcPrevistoN.add(copiePreviste[ind0].calc.getFlat(cFasciaNotturna));

            day.totali!.hPrevDiurne += copiePreviste[ind0].calc.getCount(cFasciaDiurna);
            day.totali!.hPrevNotturne += copiePreviste[ind0].calc.getCount(cFasciaNotturna);
        }
        //console.log('prev max diurne', calcPrevistoD.getCount());
        //console.log('prev max notturne', calcPrevistoN.getCount());

        let pausaDiurna = 0;
        let pausaNotturna = 0;
        if (day.pausaFlex && day.durataPausa > 0 && day.previsteLocked) {
            const copiaPausa = new Coppia(CoppiaTimbrature.getEntrata(distribuzione.pausa)!, CoppiaTimbrature.getUscita(distribuzione.pausa)!);
            const cPausa = copiaPausa.calc;

            pausaDiurna = cPausa.getCount(cFasciaDiurna);
            pausaNotturna = cPausa.getCount(cFasciaNotturna);
            let durata = day.durataPausa;
            if (pausaDiurna >= durata) {
                pausaDiurna = durata;
                pausaNotturna = 0;
            } else {
                pausaDiurna = Math.min(durata, pausaDiurna);
                durata -= pausaDiurna;
                pausaNotturna = Math.min(durata, pausaNotturna);
            }
        }
        if (distribuzione.decurtaPausa) {
            day.totali!.hPrevDiurne -= pausaDiurna;
            day.totali!.hPrevNotturne -= pausaNotturna;
        }
        day.totali!.hPausaDiurne = pausaDiurna;
        day.totali!.hPausaNotturne = pausaNotturna;
        // CALCOLO PREVISTO *** FINE ***
        // *****************************

        const causaliWF = new CausaliWF(lavoratore, gestione.causaliWF, gestione.causaliWFElaborate, cache, giornataBloccataConWF);

        if (day.anomalia === -3) {

            const calcLavoratoD = new Calc();
            const calcLavoratoN = new Calc();
            const copieArr = PresenzeGiornataPlusRecord.getCopieArrotondate(day);
            day.totali!.hLavDiurne = 0;
            day.totali!.hLavNotturne = 0;
            day.totali!.hOrdDiurne = 0;
            day.totali!.hOrdNotturne = 0;
            for (let indE = 0; indE < copieArr.length; ++indE) {
                calcLavoratoD.add(copieArr[indE].calc.getFlat(cFasciaDiurna));
                calcLavoratoN.add(copieArr[indE].calc.getFlat(cFasciaNotturna));
                day.totali!.hLavDiurne += copieArr[indE].calc.getCount(cFasciaDiurna);
                day.totali!.hLavNotturne += copieArr[indE].calc.getCount(cFasciaNotturna);
            }
            //console.log('lav diurne', calcLavoratoD.getCount());
            //console.log('lav notturne', calcLavoratoN.getCount());
            // Il conteggio delle ore lavorate ordinarie deve riflettere solo la conta singola, eventuali sovrapposizioni vanno ignorate e sono utili solo per determinare le eccedenti
            day.totali!.hOrdDiurne = calcLavoratoD.getSingleCount(calcPrevistoD);
            day.totali!.hOrdNotturne = calcLavoratoN.getSingleCount(calcPrevistoN);
            //console.log('lav ord diurne', day.totali.hOrdDiurne);
            //console.log('lav ord notturne', day.totali.hOrdNotturne);

            day.totali!.hOrdDiurneNC = 0;
            day.totali!.hOrdNotturneNC = 0;
            if (day.tipoRilevazione !== "MANUALE") { // SOLO x PLUS, calcolo ore ordinarie non computabili
                // Gestione scarti su arrotondamento minutario - INIZIO -
                // Arrotondamento ordinario
                this.setupTabArrotondamenti(distribuzione);
                let arrotondaOrdinarie = false;
                if (!distribuzione.tabArrotondamenti) {
                    console.log("Tabella arrotondamenti non impostata!");
                }
                arrotondaOrdinarie = arrotondaOrdinarie || !!distribuzione.tabArrotondamenti?.arrotondaOrdinarie;
                arrotondaOrdinarie = arrotondaOrdinarie || !!distribuzione.tabArrotondamentiUscita?.arrotondaOrdinarie;
                arrotondaOrdinarie = arrotondaOrdinarie || !!distribuzione.tabArrotondamentiInfragiornaliero?.arrotondaOrdinarie;

                if (arrotondaOrdinarie && RiepilogoOrePlus.calcolaMancante(day.totali!, distribuzione) > 0) {
                    const ordinarie = RiepilogoOrePlus.getTotaleHOrd(day.totali!);
                    let scartoMinimo = 0; // se rimane 0 non applico alcun arrotondamento alle ordinarie!
                    for (let indGiuHH = 0; indGiuHH < day.causaliHH.length; ++indGiuHH) {
                        const causale = day.causaliHH[indGiuHH];
                        if (causale) {
                            const giu = cache.getGiustificativo(causale.codGiu);
                            if (giu !== null && GiustificativoRecord.isMancante(giu)) {
                                scartoMinimo = giu.decimaleMultipliDi;
                                // N.B. decimaleMultipliDi è in centesimi!
                                //scartoMinimo *= 60.0;
                                //scartoMinimo /= 100.0;
                                break;
                            }
                        }
                    }
                    if (scartoMinimo > 0 && (ordinarie % scartoMinimo !== 0)) {
                        const restoDiurno = day.totali!.hOrdDiurne % scartoMinimo;
                        if (restoDiurno !== 0) {
                            day.totali!.hOrdDiurne -= restoDiurno;
                            day.totali!.hOrdDiurneNC = restoDiurno;
                        }
                        const restoNotturno = day.totali!.hOrdNotturne % scartoMinimo;
                        if (restoNotturno !== 0) {
                            day.totali!.hOrdNotturne -= restoNotturno;
                            day.totali!.hOrdNotturneNC = restoNotturno;
                        }
                    }
                }
                // Gestione scarti su arrotondamento minutario - FINE -
            }

            let mancanteInTolleranza = 0;
            const rilevaMancante = (): number => {

                let mancante: number = RiepilogoOrePlus.calcolaMancante(day.totali!, gestione.distribuzioneTurno!);
                if (mancante === 0) {
                    day.totali!.hMancanti = 0;
                    // Verifico che non vi siano giu a copertura di mancante!
                    for (let indGiuHH = 0; indGiuHH < day.causaliHH.length; ++indGiuHH) {
                        const causale = day.causaliHH[indGiuHH];
                        if (causale) {
                            const giu = cache.getGiustificativo(causale.codGiu);
                            if (giu !== null && GiustificativoRecord.isMancante(giu)) {
                                if (causale.quantita !== null && causale.quantita !== 0) {
                                    PresenzeGiornataPlusRecord.setAnomalia(day, 4);
                                    break;
                                }
                            }
                        }
                    }
                } else {
                    mancante = PresenzeGiornataPlusRecord.getMancante(day, cache, true, gestione.distribuzioneTurno!); // rileva mancante non giustificato in centesimi, true permette di valorizzare l'eventuale giustificativo indicato dall'utente per risolvere l'anomalia
                    if (mancante > 0) {
                        PresenzeGiornataPlusRecord.setAnomalia(day, 1);
                    } else if (mancante < 0) {
                        PresenzeGiornataPlusRecord.setAnomalia(day, 4);
                    }
                    mancante *= 60; // riporto mancante in minuti per eventuale compensazione futura
                }
                return mancante;
            };

            // 24/9/2021
            // N.B. prima di chiamare <rilevaMancante> occorrerebbe cancellare tutti i giu automatici (di qualsiasi tipo);
            // il rischio è quello di dover calcolare DUE volte la giornata per rimuovere false anomalie!
            // Vedi giustificazione automatica con mancante e poi valorizzazione delle timbrature manuali a copertura del mancante stesso: servono 2 calcoli!

            /* cancello eventuali giu automatici per tolleranza */
            GiuAutomatici.cancelloGiuTolleranza(cache, day);

            let mancante = rilevaMancante();

            const tabellaGiustificazioneAuto = cache.getTabellaGiustificazioneAuto(tabelle.idTabGiuRicorrenti);
            let tabellaGiustAutoDaStatus = null;
            const regoleGiustificazioneDaStatus = [];

            /* applico tolleranza */
            day.totali!.mRitardo1 = 0;
            day.totali!.mRitardo2 = 0;
            day.totali!.mRitardo3 = 0;
            day.totali!.mRitardo4 = 0;
            if (mancante > 0 && tabelle.idTabTolleranza !== null) {
                const tolleranza = cache.getTabellaTolleranza(tabelle.idTabTolleranza);
                if (tolleranza && tolleranza.abilitaTolleranza) {

                    console.log("Tolleranza abilitata");
                    const copieEff = PresenzeGiornataPlusRecord.getCopieEffettive(day);
                    if (copiePreviste.length > 0 && copieEff.length > 0) {
                        let mancanteDaGiustificare1 = 0;
                        let mancanteDaGiustificare2 = 0;
                        for (let indP = 0; indP < copiePreviste.length; ++indP) {
                            const ritardoTollerato = ((indP === 0) ? tolleranza.entrata1Bonus : tolleranza.entrata2Bonus);
                            if (copieEff.length > indP && copieArr.length > indP) {
                                if (ritardoTollerato > 0) {
                                    let copia = new Coppia(copiePreviste[indP].getInizio()!, copieEff[indP].getInizio()!);
                                    let cMancante = new Calc(copia);
                                    const mancanteToll = cMancante.getCount();
                                    console.log(mancanteToll);
                                    if (mancanteToll > 0 && mancanteToll <= ritardoTollerato) {
                                        const tollera = that.tolleranzaNeiLimiti(day, tolleranza, mancanteToll);
                                        if (tollera) {
                                            // IN TOLLERANAZA
                                            copia = new Coppia(copiePreviste[indP].getInizio()!, copieArr[indP].getInizio()!);
                                            cMancante = new Calc(copia);
                                            if (indP === 0) {
                                                day.totali!.mRitardo1 += mancanteToll;
                                                mancanteDaGiustificare1 = cMancante.getCount();
                                            }
                                            if (indP > 0) {
                                                day.totali!.mRitardo2 += mancanteToll;
                                                mancanteDaGiustificare2 = mancanteDaGiustificare2 + cMancante.getCount();
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        /**
                         * Verifico sussistenza tolleranza in ingresso dopo pausa flessibile
                         */
                        if (day.pausaInTolleranza && day.pausaInTolleranza.valid) {
                            const tollera = that.tolleranzaNeiLimiti(day, tolleranza, day.pausaInTolleranza.ritardo);
                            if (tollera) {
                                day.totali!.mRitardo2 += day.pausaInTolleranza.ritardo;
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                mancanteDaGiustificare2 = mancanteDaGiustificare2 + day.pausaInTolleranza.mancante;
                            }
                        }

                        if ((tolleranza.entrata1GiuBonus === tolleranza.entrata2GiuBonus) && (mancanteDaGiustificare1 + mancanteDaGiustificare2 > 0)) {
                            regoleGiustificazioneDaStatus.push(TolleranzaRecord.getRegolaBonus(tolleranza, 1, mancanteDaGiustificare1 + mancanteDaGiustificare2));
                        } else {
                            if (mancanteDaGiustificare1 > 0) {
                                regoleGiustificazioneDaStatus.push(TolleranzaRecord.getRegolaBonus(tolleranza, 1, mancanteDaGiustificare1));
                            }
                            if (mancanteDaGiustificare2 > 0) {
                                regoleGiustificazioneDaStatus.push(TolleranzaRecord.getRegolaBonus(tolleranza, 2, mancanteDaGiustificare2));
                            }
                        }
                        mancanteInTolleranza = mancanteDaGiustificare1 + mancanteDaGiustificare2;
                    }
                }
            }
            //debugger;
            if (!ricalcolo) {
                const cancellaTuttiGliAutomatici = calcoloMassivo;
                GiuAutomatici.cancelloGiuAutomatici(cache, day, tabellaGiustificazioneAuto, cancellaTuttiGliAutomatici);
                that.aggiornaSaldiAccumuli(day);

                for (let indStatus = 0; indStatus < gestione.elencoStatus.length; ++indStatus) {
                    const status = gestione.elencoStatus[indStatus];
                    if (GiustificazioneRecord.isValid(status.astensione)) {
                        const regola = GiustificazioneAutoRecord.factory(status.astensione);
                        if ((day.tipoRilevazione === "MANUALE") && regola.controllo === "COME_PREVISTO") {
                            regola.controllo = "COME_MANCANTE";
                        }
                        regola.azioneXGiuPresente = "SOSTITUISCI";
                        regola.tipologiaGiornata = "QUALSIASI";
                        regola.controlloSuPrevisto = "QUALSIASI";
                        regola.controlloSuOreLavorate = "QUALSIASI";
                        regola.controlloSuOreMancanti = "QUALSIASI";
                        regola.controlloAltriGiu = "NESSUN_CONTROLLO";
                        regola.controlloAccumulo = "NESSUN_CONTROLLO";

                        if (status.codice === gestione.proprietaGestione.codStatusRicovero) { // es. 'RICOSP'
                            regola.codGiuDaSostituire = gestione.proprietaGestione.codGiuMalattiaTemp; // es. 'MLT'
                        }

                        regoleGiustificazioneDaStatus.push(regola);
                    }
                }
                if (regoleGiustificazioneDaStatus.length > 0) {
                    tabellaGiustAutoDaStatus = TabellaGiustAutoRecord.factory({
                        idTabella: 0,
                        descrizione: "da status lavoratore",
                        enabled: true,
                        regole: regoleGiustificazioneDaStatus
                    });
                    GiuAutomatici.cancelloGiuAutomatici(cache, day, tabellaGiustAutoDaStatus, cancellaTuttiGliAutomatici);
                    that.aggiornaSaldiAccumuli(day);
                    mancante = rilevaMancante();
                }
            }

            const giuAutomatici = new GiuAutomatici(gestione, cache);
            let contaGiu = 0;
            const mancanteXGiuFS: PresenzeGiustificativo | null = PresenzeGiornataPlusRecord.getMancanteFestivo(day, cache);
            let applicaAttestati = true; // Verifico se applicare la malattia da attestati
            if (tabellaGiustAutoDaStatus && !ricalcolo && gestione.proprietaGestione.controlloAccumuloML && gestione.proprietaGestione.controlloAccumuloML !== "NESSUN_CONTROLLO") {
                // Inserisco e tolgo giustificazione da status per verificare la presenza di eventuali giustificativi prioritari rispetto alla malattia (esempio maternità prioritaria alla malattia)
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const result = giuAutomatici.applicaGiuAuto(day, tabellaGiustAutoDaStatus, calcoloMassivo, cFasciaDiurna, cFasciaNotturna, calcPrevistoD, calcPrevistoN, mancante, mancanteXGiuFS);
                const regola = GiustificazioneAutoRecord.factory();
                regola.controlloAccumulo = gestione.proprietaGestione.controlloAccumuloML;
                regola.codiceAccumulo = gestione.proprietaGestione.codiceAccumuloML;
                applicaAttestati = giuAutomatici.chkAccumulo(day, regola, gestione.totaliMese!.accumuliCHK, 0);
                GiuAutomatici.cancelloGiuAutomatici(cache, day, tabellaGiustAutoDaStatus, false);
                that.aggiornaSaldiAccumuli(day);
            }

            // N.B. in data 21/03/2025 la chiamata è stata spostata dopo il caricamento del WF!

            /* APPLICO CAUSALI WORKFLOW - WF */
            let adeguaArrotondate = false;
            switch (quantitaTimbrature) {
                case "COME_DA_ORARIO":
                case "A_CONSUNTIVO":
                    break;

                case "UNA":	// Una timbratura
                case "DUE":	// Due timbrature
                case "DUE_ENTRATE":	// Due timbrature (solo in entrata)
                case "CON_O_SENZA":	// Con o senza timbrature
                    adeguaArrotondate = true;
                    if (mancante === 0) {
                        mancante = causaliWF.applica("ORE_MANCANTI", day, mancante, rilevaMancante, true).mancante;
                        nextRicalcolo = nextRicalcolo || (mancante > 0);
                        // N.B. il mancante cosi' valorizzato verrà passato alla prossima chiamata this.applicaCausaliWF()!
                    }
                    break;
            }
            const mancantePrecedente = mancante;
            let resulApplicaWF: { mancante: number; ricalcola: boolean; numCausaliEccedenti: number };

            resulApplicaWF = causaliWF.applica("ORE_MANCANTI", day, mancante, rilevaMancante, false);
            mancante = resulApplicaWF.mancante;
            nextRicalcolo = nextRicalcolo || resulApplicaWF.ricalcola;

            causaliWF.applica("QUANTITA", day, mancante, null, false);

            if (applicaAttestati) {
                // Applico giustificazione automatica da attestati INPS
                const result = this.attestatiINPS.applica(day, mancante, null, calcoloMassivo, mancanteXGiuFS);
                contaGiu += result.count;
                if (result.ricalcola) {
                    // Solo per rilevazione manuale! ricalcolo la giornata e copio previsto in arrotondate
                    nextRicalcolo = true;
                    // copio previsto in arrotondate!
                    PresenzeGiornataPlusRecord.copyPrevisto(day);
                }
                if (contaGiu > 0) {
                    mancante = rilevaMancante();
                }
                gestione.giustificativiAttestatiElaborati = this.attestatiINPS.getAttestatiElaborati();
            }

            /* CALCOLO ECCEDENTE */
            gestione.tabQuantificaEcc = cache.getTabellaQuantificaEcc(tabelle.idTabEccedentiQuanti);
            gestione.tabQualificaEcc = cache.getTabellaQualificaEcc(tabelle.idTabEccedentiQuali);
            if ((day.tipoRilevazione === "MANUALE") && !gestione.tabQuantificaEcc) {
                gestione.tabQuantificaEcc = QuantificaEccRecord.factory(OreEccedenti.defaultQuantificaEccSTD);
            }
            const oreEccedenti = new OreEccedenti(gestione.tabQuantificaEcc!, gestione.tabQualificaEcc!, distribuzione, cache);
            oreEccedenti.quantificaEccedente2(day, cFasciaDiurna, cFasciaNotturna, calcPrevistoD, calcPrevistoN, calcoloMassivo);

            resulApplicaWF = causaliWF.applica("ORE_ECCEDENTI", day, 0, null, false);
            const numCausaliEccedenti = resulApplicaWF.numCausaliEccedenti;

            // Ricalco se:
            // Gli automatismi da WF riguardano il caricamento di giustificativi su mancante con quantità minime e multipli tali da implicare l'abbattimento delle ore lavorate
            // ho ore eccedenti da WF senza timbrature effettive!!!
            if ((mancantePrecedente > 0 && mancante < 0) || (day.effettive.length === 0 && day.arrotondateLocked && (numCausaliEccedenti > 0))) {
                nextRicalcolo = true;
            }

            if (adeguaArrotondate) {
                nextRicalcolo = nextRicalcolo || (numCausaliEccedenti > 0);
            }

            const newCausali = oreEccedenti.qualificaEccedente(day,

                cFasciaDiurna,
                cFasciaNotturna,
                compensa,
                mancante - mancanteInTolleranza,
                calcoloMassivo);

            const count = PresenzeGiornataPlusRecord.addCausaliHH(day, newCausali, GestionePlus.maxCausaliOre);
            that.checkOverflowGiu(day, count, newCausali);

            mancante = rilevaMancante();

            // Verifico quadratura eccedenze
            let totEcc = RiepilogoOrePlus.getTotaleHEcc(day.totali!) / 60;
            for (let indGiu = 0; indGiu < day.causaliHH.length; ++indGiu) {
                const causale = day.causaliHH[indGiu];
                if (causale) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu && GiustificativoRecord.isEccedente(giu)) {
                        const quantitaCausale = Math.round(causale.quantita * 1000) / 1000;
                        totEcc -= quantitaCausale;
                    }
                }
            }
            totEcc = Math.round(totEcc * 1000) / 1000;
            if (totEcc < 0) {
                PresenzeGiornataPlusRecord.setAnomalia(day, 4);
            }

            // Check limite 13hh max al giorno
            if (RiepilogoOrePlus.getTotaleHLav(day.totali) > 780) {
                PresenzeGiornataPlusRecord.setWarning(day, 16384);
            }

            {
                const mancanteXGiuFS = PresenzeGiornataPlusRecord.getMancanteFestivo(day, cache);
                const result = giuAutomatici.applicaGiuAuto(day, tabellaGiustAutoDaStatus!, calcoloMassivo, cFasciaDiurna, cFasciaNotturna, calcPrevistoD, calcPrevistoN, mancante, mancanteXGiuFS);
                contaGiu += result.count;
                if (result.ricalcola) {
                    // Solo per rilevazione manuale! ricalcolo la giornata e copio previsto in arrotondate
                    nextRicalcolo = true;
                    // copio previsto in arrotondate!
                    PresenzeGiornataPlusRecord.copyPrevisto(day);
                }
            }
            if (contaGiu > 0) {
                mancante = rilevaMancante();
            }

            if (!nextRicalcolo) {
                const result = giuAutomatici.applicaGiuAuto(day,
                    tabellaGiustificazioneAuto!,
                    calcoloMassivo,
                    cFasciaDiurna,
                    cFasciaNotturna,
                    calcPrevistoD,
                    calcPrevistoN,
                    mancante,
                    null,
                    gestione.totaliMese!.accumuliCHK);
                contaGiu += result.count;
                if (result.ricalcola && !params.ricalcolo) {
                    // Solo per rilevazione manuale! ricalcolo la giornata e copio previsto in arrotondate
                    nextRicalcolo = true;
                    // copio previsto in arrotondate!
                    PresenzeGiornataPlusRecord.copyPrevisto(day);
                }
            }

            if (contaGiu > 0) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if ((day.anomalia === 1) || (day.anomalia === 4)) {
                    day.anomalia = -3;
                }
                mancante = rilevaMancante();
            }

            // Gestione specifiche di produzione
            const specificheDiProduzione = new SpecificheDiProduzione(gestione, cache);
            specificheDiProduzione.caricaGiu(day);

            // Verifica sommatoria scorporo
            if (RiepilogoOrePlus.isCorrectDiurno(day.totali!) && RiepilogoOrePlus.isCorrectNotturno(day.totali!)) {
                if (day.anomalia === -3) {
                    PresenzeGiornataPlusRecord.setAnomalia(day, 0);
                }
                if ((day.anomalia === 0) && !calcoloMassivo) {
                    day.giornataBloccata = true;
                }
            } else {
                PresenzeGiornataPlusRecord.setAnomalia(day, 20);
            }
        } else {
            // Anche se timbrature non corrette, applico comunque giustificativi a quantità provenienti da WF, utile proprio per gestione mancata timbratura
            causaliWF.applica("QUANTITA", day, 0, null, false);
        }

        // aggiorno elenco delle causali elaborate!
        gestione.causaliWFElaborate = causaliWF.getCausaliWFElaborate();

        if (nextRicalcolo) {
            // Ricalcolo intera giornata per intervento da WF!
            this._calcolaGiornata({...params, ricalcolo: true});
        }

        // Verifico validità quantità giustificativi
        let quantitaValida = true;
        if (day.tipoRilevazione !== "MANUALE") {
            for (let indCausale = 0; indCausale < day.causaliHH.length; ++indCausale) {
                const giustificativo = day.causaliHH[indCausale];
                if (giustificativo && giustificativo.codGiu) {
                    giustificativo.quantitaValida = PresenzeGiornataPlusRecord.isQuantitaValida(day, giustificativo.quantita, cache.getGiustificativo(giustificativo.codGiu));
                    quantitaValida = quantitaValida && giustificativo.quantitaValida;
                }
            }
            for (let indCausale = 0; indCausale < day.causaliQI.length; ++indCausale) {
                const giustificativo = day.causaliQI[indCausale];
                if (giustificativo !== null && giustificativo.codGiu !== "") {
                    giustificativo.quantitaValida = PresenzeGiornataPlusRecord.isQuantitaValida(day, giustificativo.quantita, cache.getGiustificativo(giustificativo.codGiu));
                    quantitaValida = quantitaValida && giustificativo.quantitaValida;
                }
            }

            if (!quantitaValida && day.anomalia === 0) {
                PresenzeGiornataPlusRecord.resetAnomalia(day);
                PresenzeGiornataPlusRecord.setAnomalia(day, 99);
            }
        }

        // Verifico se vi sono giustificativi da WF con setup ANOMALIA!
        if (gestione.causaliWF && gestione.causaliWF.length) {
            for (let indCausale = 0; ((indCausale < gestione.causaliWF.length) && (day.anomalia === 0)); ++indCausale) {
                const causaleWF = gestione.causaliWF[indCausale];
                if (causaleWF.giornoDt === day.dtGiornata) {
                    if (causaleWF.causaleWF!.tipoCausale === "ORE_MANCANTI" && causaleWF.causaleWF!.azioneMancante === "COME_WF_ANOMALIA") {
                        for (let indGiu = 0; indGiu < day.causaliHH.length; ++indGiu) {
                            const giustificativo = day.causaliHH[indGiu];
                            if (giustificativo !== null && giustificativo.idWF === causaleWF.wf.idWF) {
                                if (giustificativo.codGiu === causaleWF.aggancio?.codGiu) {
                                    PresenzeGiornataPlusRecord.resetAnomalia(day);
                                    PresenzeGiornataPlusRecord.setAnomalia(day, 24);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        //****************
        // FINE CALCOLO!!!
        //****************
    };

    private tolleranzaNeiLimiti = (day: PresenzeGiornataPlusRecord, tolleranza: TolleranzaRecord, ritardoDaTollerare: number) => {
        let tollera = true;
        if (tolleranza.ordinaEventi === "NON_ORDINARE") {
            let totaleRitardo = 0;
            let numEventi = 0;
            this._forEachDay(function (giornata, _indexGiornata, _weekRif, _soloMeseRif) {
                totaleRitardo = totaleRitardo + giornata.totali!.mRitardo1;
                totaleRitardo = totaleRitardo + giornata.totali!.mRitardo2;
                if (giornata.totali!.mRitardo1 > 0) {
                    numEventi = numEventi + 1;
                }
                if (giornata.totali!.mRitardo2 > 0) {
                    numEventi = numEventi + 1;
                }
            }, tolleranza.periodoControllo === "MESE" ? null : day.week, true);
            if (totaleRitardo + ritardoDaTollerare > tolleranza.maxMinuti) {
                tollera = false;
                PresenzeGiornataPlusRecord.setWarning(day, 256);
            }
            if (numEventi + 1 > tolleranza.maxEventi) {
                tollera = false;
                PresenzeGiornataPlusRecord.setWarning(day, 256);
            }
        }
        return tollera;
    };

    /**
     * metodo per adeguare le arrotondate sulla base di eventuali giustificativi a copertura di mancante per le seguenti modalità di gestione:
     * 'UNA','DUE','DUE_ENTRATE','CON_O_SENZA'... timbrature
     * FINO al 15/2/2023 N.B. SOLO per la gestione standard, valuto anche la presenza di giustificativi di eccedenza
     * DAL 16/2/2023 valuto anche la presenza di giustificativi di eccedenza anche per la PLUS, differenziando la gestione per quelle che arrivano da WF!
     * @param day
     * @param monteOreCopertoDay
     */
    private adeguaArrotondate = (day: PresenzeGiornataPlusRecord, monteOreCopertoDay: number | null = null) => {
        const eccedenti: { quantita: number, coppia: Coppia | null }[] = [];
        let eccedenteManuale = 0;

        // Prelevo mancante giustificato
        if (monteOreCopertoDay === null) { // todo attenzione alla condizione
            monteOreCopertoDay = 0;
            for (let indGiuHH = 0; indGiuHH < day.causaliHH.length; ++indGiuHH) {
                if (day.causaliHH[indGiuHH]) {
                    const causale = day.causaliHH[indGiuHH]!;
                    const giu = this.cache.getGiustificativo(causale.codGiu);
                    if (giu) {
                        if (GiustificativoRecord.isMancante(giu)) {
                            monteOreCopertoDay += (causale.quantita);
                        } else if (GiustificativoRecord.isEccedente(giu)) {
                            if (causale.idWF === 0 || (day.tipoRilevazione === "MANUALE")) {
                                eccedenteManuale += (causale.quantita);
                            } else {
                                const causaleWF = this.getCausaleWF(causale.idWF)!;
                                eccedenti.push({quantita: causale.quantita, coppia: PresenzeCausaleWFRecord.getCoppia(causaleWF)});
                            }
                        }
                    }
                }
            }
        }

        // N.B. la somma dei giustificativi è in centesimi
        // Verifico mancante
        PresenzeGiornataPlusRecord.adeguaArrotondate(day, monteOreCopertoDay);

        // Verifico eccedente, tipoRilevazione MANUALE o caricamento manuale del giustificativo
        if (eccedenteManuale > 0) {
            let ultimaUscita: number | null = 0;
            const previste = PresenzeGiornataPlusRecord.getCopiePreviste(day);
            if (previste.length > 0) {
                ultimaUscita = previste[previste.length - 1].getFine();
            } else {
                console.warn("Determinazione timbrature x eccedente: previsto nullo!");
            }
            let newUscita = Calc.hhcc2hhmm(Calc.hhmm2hhcc(ultimaUscita) + (eccedenteManuale * 100));
            if (newUscita > 2400) {
                console.error("Oltre limite di calcolo giornaliero!");
                newUscita = 2400;
            }
            const copia = new Coppia(ultimaUscita!, newUscita);
            Timbrature.addCoppia(day.arrotondate, copia);
        }
        if (eccedenti.length > 0) { // Caricamento da WF
            const coppieArrotondate = PresenzeGiornataPlusRecord.getCopieArrotondate(day);
            for (let ind0 = 0; ind0 < eccedenti.length; ++ind0) {
                if (eccedenti[ind0].coppia) {
                    let addCoppia = true; // Verifico se le arrotondate si sovrappongono al periodo di straordinario
                    for (let ind1 = 0; ind1 < coppieArrotondate.length; ++ind1) {
                        if (coppieArrotondate[ind1].calc.getCount(eccedenti[ind0].coppia!.calc) > 0) {
                            addCoppia = false;
                            break;
                        }
                    }
                    if (addCoppia) {
                        Timbrature.addCoppia(day.arrotondate, eccedenti[ind0].coppia!);
                    }
                } else {
                    console.error("Intervallo ore eccedenti da WF non valorizzato!");
                }
            }
        }
    };

    private getCausaleWF = (idWF: number) => {
        if (this.gestione.causaliWF.length > 0) {
            for (let indCausale = 0; indCausale < this.gestione.causaliWF.length; ++indCausale) {
                const causaleWF = this.gestione.causaliWF[indCausale];
                if (causaleWF.wf.idWF === idWF) {
                    return causaleWF;
                }
            }
        }
        return null;
    };

    private prepareValidationEffettive = (day: PresenzeGiornataPlusRecord, proprieta: LavoratorePresenzeProprietaULRecord, elencoStatus: LavoratoreStatusRecord[]) => {
        const result = Timbrature.analizzaStrisciata(day.effettive);
        let setArrotondateConPrevisto = false;
        let isValid = false;
        const quantitaTimbrature = proprieta.quantitaTimbrature;
        switch (quantitaTimbrature) {
            case "COME_DA_ORARIO":
            case "A_CONSUNTIVO":
                isValid = result.isValid();
                break;

            case "UNA":	// Una timbratura
                //return (day.totali.getTotaleHPrev() === 0) || (result.numEntrate + result.numUscite) > 0;
                setArrotondateConPrevisto = (result.numEntrate + result.numUscite) > 0;
                isValid = (result.isValid() || setArrotondateConPrevisto);
                break;

            case "DUE":	// Due timbrature
                setArrotondateConPrevisto = ((result.numEntrate + result.numUscite) >= 2);
                isValid = (result.isValid() || setArrotondateConPrevisto);
                break;

            case "DUE_ENTRATE":	// Due timbrature (solo in entrata)
                setArrotondateConPrevisto = (result.numEntrate >= 2);
                isValid = (result.isValid() || setArrotondateConPrevisto);
                break;

            case "CON_O_SENZA":	// Con o senza timbrature, oppure MANUALE!!!
                let statusSuAstensione = false;
                for (let indStatus = 0; indStatus < elencoStatus.length; ++indStatus) {
                    const status = elencoStatus[indStatus];
                    if (status.astensione && GiustificazioneRecord.isValid(status.astensione)) {
                        statusSuAstensione = true;
                        break;
                    }
                }
                // IMPOSTO PREVISTO SOLO SE NN HO WORKFLOW, NON HO ATTESTATI, NON HO STATUS!!!
                if (!this.hasWorkflow4day(day) && !(this.attestatiINPS.hasAttestato4day(day).hasAttestato) && !statusSuAstensione) {
                    setArrotondateConPrevisto = !day.festivo || ((result.numEntrate + result.numUscite) > 0);
                } else {
                    // ok se l'astensione è totale, se parziale adeguo le arrotondate nel corso di calcolo
                    setArrotondateConPrevisto = false;
                }
                isValid = true;
                break;
        }
        return {setArrotondateConPrevisto: setArrotondateConPrevisto, isValid: isValid};
    };

    private isValidTimbEffettive = (day: PresenzeGiornataPlusRecord) => {
        const validation = this.prepareValidationEffettive(day, this.gestione.proprietaGestione!, this.gestione.elencoStatus);
        if (day.arrotondateLocked && validation.isValid && validation.setArrotondateConPrevisto) {
            // Copio previsto in arrotondate!
            PresenzeGiornataPlusRecord.copyPrevisto(day);
        }
        return validation.isValid;
    };

    private _forEachDay = (fun: ForEachDayFun, weekRif: StatoWeekPLUSRecord | null = null, soloMeseRif: boolean = false) => {
        Calcolo.forEachDay(this.days, this.gestione.mese, fun, weekRif, soloMeseRif);
    };

    // FINO al 15/11/2019

    private hasWorkflow4day(_day: PresenzeGiornataPlusRecord): boolean {
        return false; // todo???
    }

    private arrotonda(day: PresenzeGiornataPlusRecord, effettive: CoppiaTimbrature[], tabelle: TabellePresenze, tabFlex: FlexRecord | null) {
        const cache = this.cache;
        const proprietaGestione = this.gestione.proprietaGestione!;
        const elencoTurni = this.gestione.elencoTurni;

        const flexInIngresso = tabFlex !== null && tabFlex.abilitaFlex && tabFlex.regolaFlex === "ADEGUA_USCITA";
        const adeguaPrevistoConFlex = function (turno: TurnoRecord, scartoSuBase: number) {
            const distribuzione = TurnoRecord.getDistribuzione(turno, day.idGiorno);
            const newDistribuzione = TurnoDistribuzioneRecord.factory(distribuzione);
            const copia = CoppiaTimbrature.factory(newDistribuzione.prima!);
            copia.entrata = hhmm2moment(Number.parseInt(copia.entrata!)).plus({minutes: scartoSuBase}).toFormat("HHmm");
            copia.uscita = hhmm2moment(Number.parseInt(copia.uscita!)).plus({minutes: scartoSuBase}).toFormat("HHmm");
            newDistribuzione.prima = copia;
            /*
            newDistribuzione.seconda = TurnoDistribuzione$CopiaTimbrature.factory();
            newDistribuzione.terza = TurnoDistribuzione$CopiaTimbrature.factory();
            newDistribuzione.quarta = TurnoDistribuzione$CopiaTimbrature.factory();
            */
            return newDistribuzione;
        };

        if (proprietaGestione.quantitaTimbrature !== "A_CONSUNTIVO" && day.previsteLocked && (flexInIngresso || elencoTurni.length > 1)) {
            let usaAlternativoDaTerminale = false;
            const scarti: (number | null)[] = [];
            const scartiSuEntrata1: number[] = []; // scarti su prima entrata
            const tabellaAlt = cache.getTurniAlternativi(tabelle.idTabTurniAlt);
            let segnalaWarning = false;
            // Cerco turno piu' corrispondente alle timbrature arrotondate
            // trovo scarti... Facendo n calcoli al fine di trovare il turno corretto
            const giornoSettimana = PresenzeGiornataPlusRecord.getDayOfWeek(day); // Get the day of the week. 1 is Monday and 7 is Sunday
            for (let indTurno = 0; indTurno < elencoTurni.length; ++indTurno) {

                const turno = elencoTurni[indTurno];

                let automatico = (indTurno === 0);
                let codTerminaleAlternativo = null; // Codice del terminale utile per selezionare il turno alternativo (se automatico === 'AUTOMATICO_DA_TERMINALE')
                if (tabellaAlt && tabellaAlt.turniAlternativi) {
                    for (let ind0 = 0; !automatico && ind0 < tabellaAlt.turniAlternativi.length; ++ind0) {
                        if (tabellaAlt.turniAlternativi[ind0].distribuzione.codTurno === turno.codTurno) {
                            automatico = automatico || TabellaAlternativiTurniRecord.isAutomatico(tabellaAlt.turniAlternativi[ind0], giornoSettimana);
                            if (tabellaAlt.turniAlternativi[ind0].automatico === "AUTOMATICO_DA_TERMINALE") {
                                codTerminaleAlternativo = tabellaAlt.turniAlternativi[ind0].codTerminale;
                            }
                        }
                    }
                }

                if (automatico) {
                    //this.gestione.allineaPrevisto(day, turno, !day.previsteLocked);
                    GestionePlus.allineaPrevisto(day, turno, !day.previsteLocked, this.gestione.elencoTurni);

                    this._arrotonda(day, effettive, false); // false -> evita di settare le anomalie

                    if (day.arrotondate.length === 0) { // Fermo ricerca, senza arrotondate (e quindi in assenza di previsto) viene a meno il termine di paragone per ricercare il turno corretto!
                        break;
                    }

                    //var previste = day.getCopiePreviste(); // Chiamo getCopiePreviste() solo per normalizzare le previste, da rivedere (todo)
                    const previste = day.previste;
                    //var arrotondate = day.getCopieArrotondate(); // Chiamo getCopieArrotondate() solo per normalizzare le arrotondate, da rivedere (todo)
                    const arrotondate = day.arrotondate;

                    // Arrotondo
                    const tabelleAlt = LavoratorePresenzeProprietaULRecord.getTabelle(proprietaGestione, turno);
                    const tabFlexAlt: FlexRecord | null = cache.getTabellaFlex(tabelleAlt.idTabFlex);
                    if (tabFlexAlt !== null) {
                        const flexInIngressoAlt = tabFlexAlt && tabFlexAlt.regolaFlex === "ADEGUA_USCITA";
                        if (flexInIngressoAlt && arrotondate !== null && arrotondate.length > 0) {
                            const entrata = CoppiaTimbrature.arrotonda(arrotondate[0].entrata!, FlexRecord.getMinArrotondamento(tabFlexAlt), false);
                            CoppiaTimbrature.setEntrata(arrotondate[0], entrata);

                            if (arrotondate.length > 1) {
                                const uscita = CoppiaTimbrature.arrotonda(arrotondate[1].uscita!, FlexRecord.getMinArrotondamento(tabFlexAlt), true);
                                CoppiaTimbrature.setUscita(arrotondate[1], uscita);
                            }
                        }
                    }

                    // Raccolgo scarti
                    scarti.push(0);
                    scartiSuEntrata1.push(-1);
                    for (let indCopie = 0; indCopie < previste.length; ++indCopie) {
                        if (indCopie < arrotondate.length) {
                            let timbP = CoppiaTimbrature.getEntrata(previste[indCopie]);
                            let timbA = CoppiaTimbrature.getEntrata(arrotondate[indCopie]);
                            const scarto = this.calcScarto(timbP!, timbA!);
                            scarti[indTurno] = scarto + (scarti[indTurno] || 0);

                            if (flexInIngresso || day.durataPausa > 0) {
                                // Se flex in ingresso, confronto solo prima timbratura!
                                if (timbA! >= timbP!) { // Sei entrato dopo?
                                    scartiSuEntrata1[indTurno] = scarto;
                                }
                                // Modifica del 28/10/2019, se pausa flex, confronto solo prima timbratura!
                                break;
                            }
                            timbP = CoppiaTimbrature.getUscita(previste[indCopie]);
                            timbA = CoppiaTimbrature.getUscita(arrotondate[indCopie]);
                            scarti[indTurno] = this.calcScarto(timbP!, timbA!) + (scarti[indTurno] || 0);
                        } else {
                            // Numero timbrature nn sufficienti
                            scarti[indTurno] = null;
                            break;
                        }
                    }

                    if (codTerminaleAlternativo !== null) {
                        let scartiNulli: null | -1 = null;
                        let timbValide = 0;
                        let timbTerminaleAlt = 0;
                        for (let indTimb = 0; indTimb < day.effettive.length; ++indTimb) {
                            const timbratura = day.effettive[indTimb];
                            if (timbratura !== null) {
                                ++timbValide;
                                if ((timbratura.entrataTerminale === codTerminaleAlternativo) ||
                                    (timbratura.uscitaTerminale === codTerminaleAlternativo)) {
                                    ++timbTerminaleAlt;
                                }
                            }
                        }
                        if (day.effettive.length > 0) {
                            if (timbValide === timbTerminaleAlt) {
                                scartiNulli = -1;
                                usaAlternativoDaTerminale = true;
                            }
                            if (timbTerminaleAlt > 0 && timbTerminaleAlt < timbValide) {
                                segnalaWarning = true;
                                PresenzeGiornataPlusRecord.setWarning(day, 32768);
                            }
                        }
                        scarti[indTurno] = scartiNulli;
                    }
                } else {
                    scarti.push(null);
                    scartiSuEntrata1.push(-1);
                }
            }

            if (!usaAlternativoDaTerminale && flexInIngresso && FlexRecord.isIngressoInFlex(tabFlex, scartiSuEntrata1[0])) {
                const turno = elencoTurni[0];
                const newDistribuzione = adeguaPrevistoConFlex(turno, scartiSuEntrata1[0]);
                //this.gestione.allineaPrevisto(day, turno, !day.previsteLocked, newDistribuzione);
                GestionePlus.allineaPrevisto(day, turno, !day.previsteLocked, this.gestione.elencoTurni, newDistribuzione);
            } else {
                // Trovo scarto minore
                if (scarti.length > 0) {
                    const almenoUnoScarto = !!scarti.find(scarto => (typeof (scarto) !== 'undefined' && scarto !== null));
                    let intAlternativo = 0;
                    let scarto = scarti[intAlternativo];
                    for (let indTurno = 1; indTurno < elencoTurni.length; ++indTurno) {
                        if (scarti[indTurno] !== null) {
                            if (scarto === null || (scarti[indTurno]! < scarto)) {
                                intAlternativo = indTurno;
                                scarto = scarti[intAlternativo];
                            }
                        }
                    }

                    if (scarto !== null || !almenoUnoScarto) {
                        const turno = elencoTurni[intAlternativo];
                        let newDistribuzione = TurnoRecord.getDistribuzione(turno, day.idGiornoSviluppo, TurnoRecord.getDistribuzione(elencoTurni[0], day.idGiornoSviluppo));

                        const tabelleAlt = LavoratorePresenzeProprietaULRecord.getTabelle(proprietaGestione, turno);
                        if (tabelleAlt.idTabFlex === tabelle.idTabFlex) {
                            // Se il turno alternativo applica la stessa regola di flessibilità allora la applico al turno alternativo
                            if (flexInIngresso && FlexRecord.isIngressoInFlex(tabFlex, scartiSuEntrata1[intAlternativo])) {
                                newDistribuzione = adeguaPrevistoConFlex(turno, scartiSuEntrata1[intAlternativo]);
                            }
                        }
                        //this.gestione.allineaPrevisto(day, turno, !day.previsteLocked, newDistribuzione);
                        GestionePlus.allineaPrevisto(day, turno, !day.previsteLocked, this.gestione.elencoTurni, newDistribuzione);
                        if (segnalaWarning) {
                            PresenzeGiornataPlusRecord.setWarning(day, 32768);
                        }
                    }
                }
            }
            // 2/7/2019, fix pulizia dopo tentativi ricerca miglior alternativo
            day.arrotondate = [];
        }

        this._arrotonda(day, effettive);
    }

    private applicaFlex(day: PresenzeGiornataPlusRecord, tabFlex: FlexRecord, calcoloMassivo: boolean = false): CoppiaTimbrature[] {
        const flex = new Flex(day, tabFlex, calcoloMassivo);
        return flex.applica();
    }

    private setupTabArrotondamenti = (distribuzione: TurnoDistribuzioneRecord) => {
        const cache = this.cache;
        if (TurnoDistribuzioneRecord.isArrotondamentoDaTabella(distribuzione)) {
            if (!distribuzione.tabArrotondamenti) {
                distribuzione.tabArrotondamenti = cache.getTabellaArrotondamenti(distribuzione.idTabArrotondamenti);
            }
        }
        if (TurnoDistribuzioneRecord.isArrotondamentoUscitaDaTabella(distribuzione)) {
            if (!distribuzione.tabArrotondamentiUscita) {
                const idTabella = distribuzione.tipoArrotondamentoUscita ? distribuzione.idTabArrotondamentiUscita : distribuzione.idTabArrotondamenti;
                distribuzione.tabArrotondamentiUscita = cache.getTabellaArrotondamenti(idTabella);
            }
        }
        if (TurnoDistribuzioneRecord.isArrotondamentoInfragiornalieroDaTabella(distribuzione)) {
            if (!distribuzione.tabArrotondamentiInfragiornaliero) {
                const idTabella = distribuzione.tipoArrotondamentoInfragiornaliero ? distribuzione.idTabArrotondamentiInfragiornaliero : distribuzione.idTabArrotondamenti;
                distribuzione.tabArrotondamentiInfragiornaliero = cache.getTabellaArrotondamenti(idTabella);
            }
        }
    };

    // Dal 15/11/2019 restituisce lo scarto in minuti, più preciso e utile per successive elaborazioni (esempio flex su ingresso di nuova tipologia => ADEGUA_USCITA)
    private _arrotonda(day: PresenzeGiornataPlusRecord, effettive: CoppiaTimbrature[], settaAnomalia: boolean = true) {
        const cache = this.cache;
        const turno = this.getTurno(day.codTurno)!;
        const tabelle = LavoratorePresenzeProprietaULRecord.getTabelle(this.gestione.proprietaGestione!, turno!);
        const index = day.idGiorno;
        const distribuzione = TurnoRecord.getDistribuzione(turno, index);

        // Aggiorno durata e flag pausa nel caso sia stato applicato un turno alternativo!
        day.durataPausa = day.previsteLocked ? distribuzione.minMinutiPausa : 0;
        day.pausaFlex = day.durataPausa > 0;

        let pausaFlex: boolean = day.pausaFlex;
        let timbPausaFlex: number[] = []; // zero based
        let effettiveTemp: CoppiaTimbrature[] = Timbrature.defragStrisciata(effettive);

        if (pausaFlex && distribuzione.minMinutiPausa > 0) { // cerco timbrature in fascia pausa

            let pausaNonFruita = false;

            if (effettiveTemp.length === 1) {
                // Se la pausa non è stata fatta allora verifico se decurtare i minuti minimi obbligatori,
                // lo faccio se timbratura entrata precedente inizio pausa e
                // timbratura uscita maggiore fine pausa
                pausaNonFruita = CoppiaTimbrature.getEntrata(effettiveTemp[0])! < CoppiaTimbrature.getEntrata(distribuzione.pausa)! &&
                    CoppiaTimbrature.getUscita(effettiveTemp[0])! > CoppiaTimbrature.getUscita(distribuzione.pausa)!;
                if (pausaNonFruita) {
                    if (settaAnomalia && distribuzione.segnalaMancataPausa) {
                        PresenzeGiornataPlusRecord.setWarning(day, 1);
                        console.warn("Warning: " + PresenzeGiornataPlusRecord.getDescrizioneWarning(1));
                    }
                    // quindi carico nell'effettive da arrotondare la pausa minima convenzionale
                    effettiveTemp = this.impostaPausa(effettiveTemp, distribuzione, true);
                }
            }

            if (effettiveTemp.length > 1) {
                timbPausaFlex = this.rilevaTimbPausa(effettiveTemp, distribuzione);
                // Confermo attivazione pausa flessibile se ho trovato almeno 2 timbrature nella fascia!
                pausaFlex = (timbPausaFlex.length === 2);
            } else {
                pausaFlex = false;
            }
        }
        if (settaAnomalia) {
            day.pausaFlex = pausaFlex;
        }
        let offset: number = 0;
        const pausa = CoppiaTimbrature.factory();
        let indexTimb = 0;

        // Verifico se è necessario inserire le timbrature da previsto
        if (day.previsteLocked) {
            effettiveTemp = this.inserisciTimbDaPrevisto(distribuzione, effettiveTemp, day);
        }

        this.setupTabArrotondamenti(distribuzione);

        for (let indE = 0; indE < effettiveTemp.length; ++indE) {
            if (day.arrotondate.length < (indE + 1)) {
                day.arrotondate.push(CoppiaTimbrature.factory());
            }
            const ultimaCoppia = (indE === effettiveTemp.length - 1);
            let timbraturaArr: number | null;
            let timbraturaEff: number | null;
            if (TurnoDistribuzioneRecord.isArrotondamentoDaTabella(distribuzione)) {

                if (!pausaFlex || timbPausaFlex.indexOf(indexTimb) === -1) {
                    timbraturaEff = CoppiaTimbrature.getEntrata(effettiveTemp[indE]);
                    if (indE === 0) {
                        timbraturaArr = TabellaArrotondamentiRecord.arrotonda(distribuzione.tabArrotondamenti!, timbraturaEff, "ENT", offset);
                    } else {
                        timbraturaArr = TabellaArrotondamentiRecord.arrotonda(distribuzione.tabArrotondamentiInfragiornaliero!, timbraturaEff, "ENT", offset);
                    }
                    CoppiaTimbrature.setEntrata(day.arrotondate[indE], timbraturaArr);
                } else { // Timbratura in fascia PAUSA FLEX
                    //let entrata: string;// = effettiveTemp[indE].getEntrata();
                    // Arrotondo timbratura pausa secondo la propria regola di arrotondamento, dal 15/7/2020, prima solo arrotondamento minutario!
                    const entrata = CoppiaTimbrature.arrotonda(effettiveTemp[indE].entrata!, TurnoDistribuzioneRecord.getMinArrotondamentoPausa(distribuzione), false);
                    CoppiaTimbrature.setUscita(pausa, entrata);
                    const result = this.adattaPrevistoSuPausa(day, pausa, distribuzione, settaAnomalia);
                    offset = result.offset ? result.offset : 0;
                    CoppiaTimbrature.setEntrata(day.arrotondate[indE], CoppiaTimbrature.getUscita(pausa));

                    /***
                     * Verifico se è necessario tollerare ritardo per pausa > maxMinutiPausa
                     */
                    if (result.mancanteExtra > 0) {
                        if (tabelle.idTabTolleranza !== null) {
                            const tolleranza = cache.getTabellaTolleranza(tabelle.idTabTolleranza);
                            if (tolleranza !== null && tolleranza.abilitaTolleranza) {
                                const durata = this.calcScarto(CoppiaTimbrature.getEntrata(effettiveTemp[indE])!,
                                    CoppiaTimbrature.getEntrata(pausa)!);
                                const ritardo = durata - distribuzione.maxMinutiPausa;
                                if (ritardo <= tolleranza.entrata2Bonus) {
                                    day.pausaInTolleranza = {ritardo: ritardo, mancante: result.mancanteExtra, valid: true};
                                }
                            }
                        }
                    }
                }
                ++indexTimb;

                if (!pausaFlex || timbPausaFlex.indexOf(indexTimb) === -1) {
                    timbraturaEff = CoppiaTimbrature.getUscita(effettiveTemp[indE]);
                    if (!ultimaCoppia) {
                        timbraturaArr = TabellaArrotondamentiRecord.arrotonda(distribuzione.tabArrotondamentiInfragiornaliero!, timbraturaEff, "USC", offset);
                        CoppiaTimbrature.setUscita(day.arrotondate[indE], timbraturaArr);
                    } else {
                        if (TurnoDistribuzioneRecord.isArrotondamentoUscitaDaTabella(distribuzione)) {
                            timbraturaArr = TabellaArrotondamentiRecord.arrotonda(distribuzione.tabArrotondamentiUscita!, timbraturaEff, "USC", offset);
                            CoppiaTimbrature.setUscita(day.arrotondate[indE], timbraturaArr);
                        } else {
                            const minArrUscita = (!distribuzione.tipoArrotondamentoUscita) ?
                                TurnoDistribuzioneRecord.getMinArrotondamento(distribuzione) :
                                TurnoDistribuzioneRecord.getMinArrotondamentoUscita(distribuzione);
                            const uscita = CoppiaTimbrature.arrotonda(effettiveTemp[indE].uscita!, minArrUscita, true);
                            CoppiaTimbrature.setUscita(day.arrotondate[indE], uscita);
                        }
                    }
                } else { // Timbratura in fascia PAUSA FLEX
                    //let uscita: string;// = effettiveTemp[indE].getUscita();
                    // Arrotondo timbratura pausa secondo la propria regola di arrotondamento, dal 15/7/2020, prima solo arrotondamento minutario!
                    const uscita = CoppiaTimbrature.arrotonda(effettiveTemp[indE].uscita!, TurnoDistribuzioneRecord.getMinArrotondamentoPausa(distribuzione), true);
                    CoppiaTimbrature.setEntrata(pausa, uscita);
                    CoppiaTimbrature.setUscita(day.arrotondate[indE], uscita);
                }
                ++indexTimb;
                if (distribuzione.tabArrotondamenti && distribuzione.tabArrotondamenti.nonAarrotondareSeEntrataMaggUscita) {
                    if (Number.parseInt(day.arrotondate[indE].entrata || "0") > Number.parseInt(day.arrotondate[indE].uscita || "0")) {
                        day.arrotondate[indE].entrata = effettiveTemp[indE].entrata;
                        day.arrotondate[indE].uscita = effettiveTemp[indE].uscita;
                    }
                }
            } else {
                // todo manca gestione pausa flex...
                const entrata = CoppiaTimbrature.arrotonda(effettiveTemp[indE].entrata!, TurnoDistribuzioneRecord.getMinArrotondamento(distribuzione), false);
                CoppiaTimbrature.setEntrata(day.arrotondate[indE], entrata);

                if (!ultimaCoppia) {
                    const uscita = CoppiaTimbrature.arrotonda(effettiveTemp[indE].uscita!, TurnoDistribuzioneRecord.getMinArrotondamento(distribuzione), true);
                    CoppiaTimbrature.setUscita(day.arrotondate[indE], uscita);
                } else {
                    if (TurnoDistribuzioneRecord.isArrotondamentoUscitaDaTabella(distribuzione)) {
                        timbraturaArr = TabellaArrotondamentiRecord.arrotonda(distribuzione.tabArrotondamentiUscita!, CoppiaTimbrature.getUscita(day.arrotondate[indE]), "USC", offset);
                        CoppiaTimbrature.setUscita(day.arrotondate[indE], timbraturaArr);
                    } else {
                        const minArrUscita = (!distribuzione.tipoArrotondamentoUscita) ?
                            TurnoDistribuzioneRecord.getMinArrotondamento(distribuzione) :
                            TurnoDistribuzioneRecord.getMinArrotondamentoUscita(distribuzione);
                        const uscita = CoppiaTimbrature.arrotonda(effettiveTemp[indE].uscita!, minArrUscita, true);
                        CoppiaTimbrature.setUscita(day.arrotondate[indE], uscita);
                    }
                }
            }
        }
    }

    // Calcola differenza tra le 2 timbrature nel formato numerico hhmm, n.b. Scarto in centesimi
    private _calcScarto(timbP: number, timbA: number) {
        let scarto: number;
        if (timbP === 0) { // se mezzanotte
            const scartoPrima = Math.abs(2400 - Calc.hhmm2hhcc(timbA));
            const scartoDopo = Math.abs(0 - Calc.hhmm2hhcc(timbA));
            scarto = Math.min(scartoPrima, scartoDopo);
        } else {
            scarto = Math.abs(Calc.hhmm2hhcc(timbP) - Calc.hhmm2hhcc(timbA));
        }
        return scarto;
    }

    // Calcola differenza tra le 2 timbrature nel formato numerico hhmm, N.B. Scarto in minuti
    private calcScarto(timbP: number, timbA: number) {
        let scarto: number;
        if (timbP === 0) { // se mezzanotte
            const dtTimbA = hhmm2moment(timbA);
            const now = DateTime.now();
            const scartoPrima = (dtTimbA.diff(now.endOf("day"), "minutes")).shiftTo("minutes").toObject();
            const scartoDopo = (now.startOf("day").diff(dtTimbA, "minutes")).shiftTo("minutes").toObject();
            scarto = Math.min(Math.abs(scartoPrima.minutes!), Math.abs(scartoDopo.minutes!));
        } else {
            const previsto = hhmm2moment(timbP);
            const arrotondate = hhmm2moment(timbA);
            const diff = (previsto.diff(arrotondate, "minutes")).shiftTo("minutes").toObject();
            scarto = Math.abs(diff.minutes!);
        }
        return scarto;
    }

    private impostaPausa(timbrature: CoppiaTimbrature[], distribuzione: TurnoDistribuzioneRecord, setMax: boolean = false) {
        return Timbrature.impostaPausa(timbrature, distribuzione, setMax);
    }

    private inserisciTimbDaPrevisto(distribuzione: TurnoDistribuzioneRecord, effettiveTemp: CoppiaTimbrature[], day: PresenzeGiornataPlusRecord) {
        const timbDaInserireL: (string | null)[] = [];
        let inserisciTimb = false;
        const previste = [distribuzione.prima, distribuzione.seconda, distribuzione.terza, distribuzione.quarta];

        for (let indP = 0; indP < previste.length; ++indP) {
            if (previste[indP]) {
                const coppia = previste[indP]!;
                if (CoppiaTimbrature.isValid(coppia)) {
                    if (coppia.generaEntrata) {
                        timbDaInserireL.push(coppia.entrata);
                        inserisciTimb = true;
                    } else {
                        timbDaInserireL.push(null);
                    }
                    if (coppia.generaUscita) {
                        timbDaInserireL.push(coppia.uscita);
                        inserisciTimb = true;
                    } else {
                        timbDaInserireL.push(null);
                    }
                }
            }
        }
        if (inserisciTimb) {
            const calcLavorato = new Calc();
            for (const coppia of PresenzeGiornataPlusRecord.getCopieEffettive(day)) {
                calcLavorato.add(coppia.calc.getFlat());
            }

            let inserisci = true;
            for (let indI = 0; indI < timbDaInserireL.length; ++indI) {
                if (timbDaInserireL[indI] !== null) {
                    const copia = new Coppia(parseInt(timbDaInserireL[indI++]!), parseInt(timbDaInserireL[indI++]!)); // todo da verificare!!!
                    const c = copia.calc.getCount();
                    if (calcLavorato.getCount(copia.calc) < c) {
                        inserisci = false;
                    }
                }
            }

            if (inserisci) {
                const effettiveTempL = [];
                const effettiveNew = [];
                for (let indE = 0; indE < effettiveTemp.length; ++indE) {
                    effettiveTempL.push(effettiveTemp[indE].entrata);
                    effettiveTempL.push(effettiveTemp[indE].uscita);
                }
                let indEffNew = 0;
                for (let indI = 0; indI < timbDaInserireL.length; ++indI) {
                    if (timbDaInserireL[indI] === null) {
                        effettiveNew.push(effettiveTempL[indEffNew]);
                        indEffNew++;
                    } else {
                        effettiveNew.push(timbDaInserireL[indI]);
                    }
                }
                effettiveTemp = [];
                for (let indE = 0; indE < effettiveNew.length;) {
                    const copiaEff = CoppiaTimbrature.factory();
                    copiaEff.entrata = effettiveNew[indE++];
                    copiaEff.uscita = effettiveNew[indE++];
                    effettiveTemp.push(copiaEff);
                }
            }
        }

        return effettiveTemp;
    }

    private consuntivaOre(day: PresenzeGiornataPlusRecord): void {
        const cache = this.cache;
        const isValid = (astensione: GiustificazioneRecord) => (astensione.codGiu !== null && astensione.codGiu !== "");
        let statusSuAstensione = false;
        for (let indStatus = 0; indStatus < this.gestione.elencoStatus.length; ++indStatus) {
            const status = this.gestione.elencoStatus[indStatus];
            //if (status.astensione !== null && status.astensione.isValid()) {
            if (status.astensione && isValid(status.astensione)) {
                statusSuAstensione = true;
                break;
            }
        }

        if (!day.previsteLocked || day.festivo || statusSuAstensione) {
            return;
        }

        const week = day.week;
        //const minMaxHContr = this.gestione.getMinMaxHContr(week!); // ret {hhMin,hhMax};
        const minMaxHContr = GestionePlusData.getMinMaxHContr(this.gestione, this.lavoratore!, week!);
        const monteOreContratto = minMaxHContr.hhMin;
        let monteOreLavorato = 0;
        let monteOreCoperto = 0;
        let monteOreCopertoDay = 0;

        /**
         * Calcolo monte ore lavorato e coperto
         */
        this._forEachDay(function (giornata, _indexGiornata, _weekRif, _soloMeseRif) {

            // Prelevo mancante giustificato
            for (let indGiuHH = 0; indGiuHH < giornata.causaliHH.length; ++indGiuHH) {
                const causale = giornata.causaliHH[indGiuHH];
                if (causale) {
                    const giu = cache.getGiustificativo(causale.codGiu);
                    if (giu && GiustificativoRecord.isMancante(giu)) {
                        if (giornata === day) { // modifica del 28/4/2020
                            monteOreCopertoDay += causale.quantita;
                        } else {
                            monteOreCoperto += causale.quantita;
                        }
                    }
                }
            }

            // Prelevo ore lavorate
            if (giornata !== day) {
                monteOreLavorato += RiepilogoOrePlus.getTotaleHOrd(giornata.totali!);
            }
        }, week, false);
        // la somma dei giustificativi è in centesimi, converto in minuti...
        monteOreCoperto *= 60;

        // Resetto previsto
        day.currentTurno = this.gestione.turnoAConsuntivo;
        day.codTurno = this.gestione.turnoAConsuntivo!.codTurno;
        day.previste = [];
        // oppure...
        // giornata.eraseTimbrature(previste);
        let previstoDisponibile = (monteOreContratto - monteOreLavorato - monteOreCoperto); // In minuti
        if (isDevelopment()) {
            console.log("monteOreContratto:", monteOreContratto);
            console.log("monteOreLavorato:", monteOreLavorato);
            console.log("monteOreCoperto:", monteOreCoperto);
            console.log("previstoDisponibile:", previstoDisponibile);
        }

        if (previstoDisponibile > 0) {
            /**
             * Adeguo previsto alle arrotondate
             */
            const coppie = PresenzeGiornataPlusRecord.getCopieArrotondate(day);
            for (let indAR = 0; indAR < coppie.length; ++indAR) {
                let coppia = coppie[indAR];
                while (coppia.calc.getCount() > previstoDisponibile) {
                    coppia = new Coppia(coppia.inizio!, Calc.hhcc2hhmm(Calc.hhmm2hhcc(coppia.fine) - 25));
                }
                const lavorato = coppia.calc.getCount();
                if (lavorato > 0) {
                    previstoDisponibile -= lavorato;
                    const coppiaTimbrature = CoppiaTimbrature.factory();
                    CoppiaTimbrature.setEntrata(coppiaTimbrature, coppia.inizio);
                    CoppiaTimbrature.setUscita(coppiaTimbrature, coppia.fine);
                    day.previste.push(coppiaTimbrature);
                }
                isDevelopment() && console.log("previstoDisponibile:", previstoDisponibile);
                if (previstoDisponibile <= 0) {
                    break;
                }
            }

            /**
             * Adeguo previsto a eventuali giustificativi a copertura di mancante
             */
            if (previstoDisponibile > 0 && monteOreCopertoDay > 0) {
                // verifico giustificativi a copertura di mancante
                let quantita = monteOreCopertoDay;
                while (quantita * 60.0 > previstoDisponibile) {
                    quantita -= 0.25;
                }
                if (quantita > 0) {
                    let coppiaTimbrature;
                    if (day.previste.length > 0) {
                        coppiaTimbrature = day.previste[day.previste.length - 1];
                    } else {
                        coppiaTimbrature = CoppiaTimbrature.factory();
                        const turno = this.gestione.elencoTurni[0];
                        const distribuzione = TurnoRecord.getDistribuzione(turno, day.idGiornoSviluppo);

                        let coppiaUtile = null;
                        if (distribuzione) {
                            const coppie = [distribuzione.prima, distribuzione.seconda, distribuzione.terza, distribuzione.quarta];
                            for (let indCoppia = 0; indCoppia < coppie.length; ++indCoppia) {
                                if (coppie[indCoppia] !== null && !CoppiaTimbrature.isNull(coppie[indCoppia])) {
                                    coppiaUtile = coppie[indCoppia];
                                    break;
                                }
                            }
                        }
                        if (coppiaUtile === null) {
                            CoppiaTimbrature.setEntrata(coppiaTimbrature, "0800");
                            CoppiaTimbrature.setUscita(coppiaTimbrature, "0800");
                            /*coppiaTimbrature.setEntrata('0000');
                            coppiaTimbrature.setUscita('0000');*/
                        } else {
                            CoppiaTimbrature.setEntrata(coppiaTimbrature, coppiaUtile.entrata);
                            CoppiaTimbrature.setUscita(coppiaTimbrature, coppiaUtile.entrata);
                        }
                    }
                    let uscita = Calc.hhmm2hhcc(CoppiaTimbrature.getUscita(coppiaTimbrature)); // 1830 -> 1850
                    uscita += (quantita * 100);
                    CoppiaTimbrature.setUscita(coppiaTimbrature, Calc.hhcc2hhmm(uscita));
                    if (day.previste.length === 0) {
                        day.previste.push(coppiaTimbrature);
                    }
                }
            }
        }
    }

    /**
     * Controlla se è stato superato il numero massimo di giustificativi inseribili per giornata; in tal caso set anomalia
     * @param day giorno in elaborazione
     * @param count numero giustificativi inseriti
     * @param newCausali array giustificativi da inserire
     */
    private checkOverflowGiu = (day: PresenzeGiornataPlusRecord, count: number, newCausali: PresenzeGiustificativo[]) => {
        if (count < newCausali.length) {
            console.error(LavoratorePresenzeRecord.getDescrizione(this.lavoratore), GestionePlus.formatDate(day.dtGiornata), "Raggiunto il limite massimo di causali!");
            PresenzeGiornataPlusRecord.setAnomalia(day, 11);
        }
    };

}